import React, { useState, useRef, useEffect, useMemo, useContext, useCallback } from 'react';
import SignaturePad from 'react-signature-canvas';
import ReactDatePicker from 'react-datepicker';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import Swal from 'sweetalert2';
import debounce from 'lodash/debounce'
import dayjs from 'dayjs';

import './CreateInvoice.css';
import ItemPricePickerDialog from '../../Components/ClientItems/SubComponents/ItemPricePickerDialog';
import { resolveItemPriceSelection } from '../../helpers/clientItemPrices';
import { shouldIncludeClientAccountCard } from '../../helpers/clientAccountCards';

import {
    Modal,
    TextField,
    Button,
    RadioGroup,
    FormControlLabel,
    Radio,
    Popper,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Autocomplete,
    Tooltip,
    Switch,
    FormControlLabel as MuiFormControlLabel,
    Box,
    Typography
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { styled } from '@mui/material/styles';

import EnumsService from '../../Services/enums.service.js';
import UserService from '../../Services/user.service.js';
import AutocompleteSelect from '../../Components/Widgets/AutocompleteSelect/AutocompleteSelect.jsx';
import cancelIcon from '../../assests/images/Icons/cancelIcon.svg';
import SignatureReferenceModal from '../../Components/Widgets/SignatureReferenceModal/SignatureReferenceModal.jsx';
import PuffLoader from "react-spinners/PuffLoader";
import TaxAuthorityService from '../../Services/taxAuthority.service.js';
import DocumentService from '../../Services/documents.service.js';
import { GetDocumentSettingsByCaseId } from '../../Services/documentSettings.service.js';
import 'react-toastify/dist/ReactToastify.css'; // Import Toastify CSS
import Constants, { ForeignCurrencyCode } from '../../assests/Constants/constants.js';
import CustomDatePicker from '../../Components/Widgets/CustomDates/CustomDatePicker/CustomDatePicker.js';
import { beautifyNumber } from '../../Utils/FormatNumber.js';
import ClientService from '../../Services/client.service.js';
import { FileContext } from '../../Contexts/FileContext.js';
import { getVatValue } from '../../Utils/GetVatValue.js';
import { getIsraelInvoiceAmountLimit } from '../../Utils/GetIsraelInvoiceAmountLimit.js';
import { validateEmail, validatePhoneNumber, isValidShaamCustomerVatNumber } from '../../Utils/helpers.js';
import ClientItemsService from '../../Services/clientItems.service.js';
import { styledInput } from '../../Utils/styledInputHelper.js';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext.js';
import ForeignCurrencyService from '../../Services/foreignCurrency.service.js';
import { useClientNavigation } from '../../hooks/useClientNavigation.js';
import ProjectsService from '../../Services/projects.service.js';
import InventoryService from '../../Services/inventory.service.js';
import { useRequireDocumentTypeAccess } from '../../hooks/useRequireDocumentTypeAccess.js';
import InactiveClientAlert from '../../Components/InactiveClientAlert/InactiveClientAlert';
import EnhancedCreateReceipt from './SubComponent/EnhancedCreateReceipt.jsx';
import { useDocumentLinking, ENTITY_TYPE, pendingLinksToLinkedDescription, toLinkDraftItems, CURRENCY_ILS } from '../../Components/TransactionDocuments/documentLifecycle.js';
import { calculateWithholdingAmount } from '../../Utils/withholdingTaxUtils.js';
import TaxAuthorityErrorModal from '../../Components/TaxAuthorityErrorModal/TaxAuthorityErrorModal.jsx';
import ReceivablesService from '../../Services/receivables.service.js';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import fieldStyles from '../../Components/JournalEntryies/SubComponents/AddJournalEntryModal.module.scss';
import receiptFieldStyles from './SubComponent/EnhancedCreateReceipt.module.scss';
import AutocompleteSelectFilter from '../../Components/Widgets/AutocompleteSelectFilter/AutocompleteSelectFilter.jsx';
import AccountCardBankDetailsBar from '../../Components/Widgets/AccountCardBankDetailsBar/AccountCardBankDetailsBar.jsx';
import { getCardBankDetails, isBankPaymentType, rowHasBankDetails } from '../../Utils/accountCardBankDetails';

// const InvoiceModalTypes = [
//     {
//         controller: 'PaymentAcceptances',
//         endPoint: 'GeneratePaymentAcceptanceDocumentPdf',
//         draftEndPoint: 'GeneratePaymentAcceptanceDocumentDraftPdf', // Assuming you have a draft endpoint
//         type: '',
//         TransactionDocumentType: '',
//         TransactionDocumentTitle: '',
//         title: 'invoiceReceipt',
//         screen: '/PaymentAcceptance',
//         type: 'PaymentAcceptance',
//     },
//     {
//         controller: 'PaymentAcceptances',
//         endPoint: 'GeneratePaymentAcceptanceDocumentPdf',
//         draftEndPoint: 'GeneratePaymentAcceptanceDocumentDraftPdf', // Assuming you have a draft endpoint
//         type: '',
//         TransactionDocumentType: '',
//         TransactionDocumentTitle: '',
//         title: 'generateCreditNote',
//         screen: '/PaymentAcceptance',
//         type: 'receipt',
//     },
// ];

const InvoiceModalTypes = [
    { controller: "Incomes", endPoint: "GenerateIncomePdf", draftEndPoint: "GenerateIncomeDraftPdf", type: "", TransactionDocumentType: "", TransactionDocumentTitle: "", title: "generateInvoice" },
    { controller: "Incomes", endPoint: "GenerateRefundIncomePdf", draftEndPoint: "GenerateRefundIncomeDraftPdf", type: "", TransactionDocumentType: "", TransactionDocumentTitle: "", title: "generateCreditNote" },
    { controller: "TransactionDocuments", endPoint: "GenerateTransactionDocumentPdf", draftEndPoint: "GenerateTransactionDocumentDraftPdf", type: "quotation", TransactionDocumentType: "Quotation", TransactionDocumentTitle: "הצעת מחיר", title: "generateQuotation" },
    { controller: "TransactionDocuments", endPoint: "GenerateTransactionDocumentPdf", draftEndPoint: "GenerateTransactionDocumentDraftPdf", type: "order", TransactionDocumentType: "Order", TransactionDocumentTitle: "הזמנה", title: "generateOrder" },
    { controller: "TransactionDocuments", endPoint: "GenerateTransactionDocumentPdf", draftEndPoint: "GenerateTransactionDocumentDraftPdf", type: "transaction", TransactionDocumentType: "Transaction", TransactionDocumentTitle: "חשבון עסקה", title: "generateTransactionInvoice" },
    {
        controller: 'PaymentAcceptances',
        endPoint: 'GeneratePaymentAcceptanceDocumentPdfV2',
        draftEndPoint: 'GeneratePaymentAcceptanceDocumentDraftPdf', // Assuming you have a draft endpoint
        TransactionDocumentType: '',
        TransactionDocumentTitle: 'חשבונית מס קבלה',
        title: 'invoiceReceipt',
        screen: '/PaymentAcceptance',
        type: 'PaymentAcceptances',
    },
    {
        controller: 'PaymentAcceptances',
        endPoint: 'GeneratePaymentAcceptanceDocumentPdfV2',
        draftEndPoint: 'GeneratePaymentAcceptanceDocumentDraftPdf', // Assuming you have a draft endpoint
        TransactionDocumentType: '',
        TransactionDocumentTitle: 'קבלה',
        title: 'receipt',
        screen: '/PaymentAcceptance',
        type: 'PaymentAcceptances',
    },
];

// Sentinel makat used to mark the auto-generated "Rounding Difference" item.
// Negative numeric value avoids collisions with real client makat numbers
// (which start at 1 and increment) and lets the backend recognize it as a
// non-persistable line item.
const ROUNDING_MAKAT = '-100';

// ====== Styled components for the table styling ======
const StyledTableContainer = styled(TableContainer)({
    marginTop: '5px',
    width: '82%',
    boxShadow: 'none',
    borderRadius: 0,
});

const StyledTable = styled(Table)({
    borderCollapse: 'collapse',
});

const StyledTableHead = styled(TableHead)({
    backgroundColor: '#BFC8FF',
    '& .MuiTableCell-head': {
        backgroundColor: '#BFC8FF',
        color: '#304FFF',
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: 600,
        textAlign: 'center',
        textTransform: 'uppercase',
        borderBottom: '2px solid #d3d3d3',
        position: 'sticky',
        top: 0
    },
});

const StyledTableRow = styled(TableRow)({
    '&:hover': {
    },
});

/** Serialize the calendar day the user picked (29/09/2026) as UTC noon so JSON ISO stays that day. */
const toLocalCalendarUtcIso = (value) => {
    const source = value?.toDate ? value.toDate() : value;
    const d = source instanceof Date ? source : (source != null && source !== '' ? new Date(source) : new Date());
    if (Number.isNaN(d.getTime())) {
        const now = new Date();
        return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0)).toISOString();
    }
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0)).toISOString();
};

const withLocalCalendarPaymentDates = (items) =>
    (Array.isArray(items) ? items : []).map((item) => ({
        ...item,
        paymentDate: toLocalCalendarUtcIso(item.paymentDate),
    }));

const StyledTableCellHeader = styled(TableCell)({
    backgroundColor: '#BFC8FF',
    color: '#304FFF',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontWeight: 600,
    textAlign: 'center',
    textTransform: 'uppercase',
    borderBottom: '2px solid #d3d3d3',
    position: 'sticky',
    top: 0
});

const StyledTableCell = styled(TableCell)({
    borderTop: '1px solid rgba(191, 191, 193, 0.56)',
    backgroundColor: 'rgba(234, 237, 255, 0.32)',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    textAlign: 'center',
    // Matches the default row height or margin/padding for your style
});

/**
 * CreateReceipt Component
 * 
 * This component creates receipts and invoices with improved design and error handling.
 * 
 * HOW TO CALL THIS FUNCTION:
 * 
 * 1. Navigate to this component with client data:
 *    navigate('/create-receipt', {
 *      state: {
 *        client: clientObject,  // Required: Client object with caseId, name, etc.
 *        type: 'ReceiptTax'     // Required: Type of document to create
 *      }
 *    });
 * 
 * 2. Example usage from another component:
 *    const handleCreateReceipt = (client) => {
 *      navigate('/create-receipt', {
 *        state: {
 *          client: client,
 *          type: 'ReceiptTax' // or 'Receipt', 'TaxInvoice', etc.
 *        }
 *      });
 *    };
 * 
 * IMPROVEMENTS MADE:
 * - Fixed client null error with proper null checking
 * - Added loading states and error handling
 * - Modern card-based design inspired by Stripe/Notion
 * - Improved responsive layout with CSS Grid
 * - Added animations and hover effects
 * - Better visual hierarchy and spacing
 * - Enhanced form validation and user feedback
 * - Mobile-responsive design
 * 
 * ERROR FIXES:
 * - Added null checks for client.caseType
 * - Added initialization loading state
 * - Added error state for missing client data
 * - Improved error messages and user guidance
 */

const CreateReceipt = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const { files } = useContext(FileContext);

    useRequireDocumentTypeAccess(location.state?.type);

    const [accountCardOptions, setAccountCardOptions] = useState([]);
    const [sortCodeIdOptions, setSortCodeIdOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [creditAccountOptions, setCreditAccountOptions] = useState([]);
    const [debitAccountOptions, setDebitAccountOptions] = useState([]);
    const [addNewAccountCardDocument, setAddNewAccountCardDocument] = useState(false);
    const [showAllAccountCards, setShowAllAccountCards] = useState(false);
    const [accountCardEditDownloadOptions, setAccountCardEditDownloadOptions] = useState([]);
    const [direction, setDirection] = useState('rtl'); // Default to 'rtl'
    const [clientItems, setClientItems] = useState([]);
    const [inventoryStockByItemId, setInventoryStockByItemId] = useState({});
    const [isFirstUserFetched, setIsFirstUserFetched] = useState(false);
    const [token, setToken] = useState('');
    const [data, setData] = useState([]);
    const [client, setClient] = useState(null);
    const [datePickerKey, setDatePickerKey] = useState(0);
    const [type, setType] = useState(null);
    const [user, setUser] = useState(null);
    const [cardIdOption, setCardIdOption] = useState(-1);
    const [newItems, setNewItems] = useState([]); // To store new items
    const [addItemFlags, setAddItemFlags] = useState([true]); // Array of booleans to track add new item mode per index
    const [pricePickerState, setPricePickerState] = useState(null);
    const [invoiceSignature, setInvoiceSignature] = useState('');
    const [invoiceReference, setInvoiceReference] = useState('');
    const [signatureReferenceFilled, setSignatureReferenceFilled] = useState(false);
    const [editedItem, setEditedItem] = useState({});
    const [totalsVisible, setTotalsVisible] = useState(true);
    const [authUrl, setAuthUrl] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isInitializing, setIsInitializing] = useState(true); // Add loading state for initialization
    const [useEnhancedVersion, setUseEnhancedVersion] = useState(true); // Toggle for enhanced version
    const [resumeInvoiceCreation, setResumeInvoiceCreation] = useState(false);
    const [draftPdfModalVisible, setDraftPdfModalVisible] = useState(false);
    const [PdfModalVisible, setPdfModalVisible] = useState(false);
    const [draftPdfPath, setDraftPdfPath] = useState('');
    const [draftPdfBlob, setDraftPdfBlob] = useState(null);
    const [PdfBlob, setPdfBlob] = useState(null);
    const [isTaxAuthorityAuthModalVisible, setIsTaxAuthorityAuthModalVisible] = useState(false);
    const [invoiceModalType, setInvoiceModalType] = useState(0); // Default to 0 for TaxInvoice
    const sigPad = useRef(null);
    // Scope used for the in-progress Tax Authority auth so the completion poll matches the
    // right token (invoices_scope for invoice receipts, Donations_scope for charity donations).
    const taxAuthScopeRef = useRef(Constants?.TaxAuthorityScopes?.CreationNumber);
    const [signatureReferenceInvoiceModalVisible, setSignatureReferenceInvoiceModalVisible] = useState(false);
    const [authModalVisible, setAuthModalVisible] = useState(false);
    const [authWindow, setAuthWindow] = useState(null);
    const [needSignature, setNeedSignature] = useState(false);
    const [needReference, setNeedReference] = useState(false);
    const { setMenuProps } = useHamburgerMenu();
    const { viewDocumentDetails, viewTransactionDocuments, viewPaymentAcceptanceDetails } = useClientNavigation(client);
    const [allClientsOfAccountant, setAllClientsOfAccountant] = useState([]);
    const [currencyRateValue, setCurrencyRate] = useState(null);
    const [isTaxAuthorityErrorModalVisible, setIsTaxAuthorityErrorModalVisible] = useState(false);
    const [pendingDecisionStatus, setPendingDecisionStatus] = useState(null);
    const [resolvePendingMode, setResolvePendingMode] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState(i18n.language || 'he'); // Default to current UI language
    const [itemsDisplayMode, setItemsDisplayMode] = useState('normal'); // 'normal' or 'descriptionOnly'

    const isInventoryDocument =
        invoiceModalType === Constants.TransactionDocumentsNames.taxInvoice ||
        invoiceModalType === Constants.TransactionDocumentsNames.creditInvoice ||
        invoiceModalType === Constants.TransactionDocumentsNames.taxInvoiceReceipt;

    useEffect(() => {
        if ((invoiceModalType === 5 || invoiceModalType === 6) && client?.leadingBusiness) {
            const fetchCaseIds = async () => {
                try {
                    const res = await EnumsService.GetClientCaseIds(
                        client.accountantId,  // your accountantId
                        client.caseId,        // your own CaseId, for auth check
                        token
                    );
                    if (!res.ok) throw new Error(`HTTP ${res.status}`);
                    const ids = await res.json();
                    setAllClientsOfAccountant(ids);
                } catch (err) {
                    console.error("Failed loading client case IDs:", err);
                }
            };

            fetchCaseIds();
        }
    }, [invoiceModalType]);



    useEffect(() => {
        setMenuProps({ client });
    }, [client, setMenuProps]);

    // Fetch document settings when client is available
    useEffect(() => {
        const fetchDocumentSettings = async () => {
            if (client?.caseId && token) {
                try {
                    const settings = await GetDocumentSettingsByCaseId(client.caseId, token);
                    const settingsObj = Array.isArray(settings) ? settings[0] : settings;
                    if (settingsObj?.itemsDisplayMode) {
                        setItemsDisplayMode(settingsObj.itemsDisplayMode);
                    }
                } catch (error) {
                    console.error('Error fetching document settings:', error);
                    // Default to 'normal' if fetch fails
                    setItemsDisplayMode('normal');
                }
            }
        };
        fetchDocumentSettings();
    }, [client?.caseId, token]);

    // Sync document language with UI language changes
    useEffect(() => {
        setSelectedLanguage(i18n.language || 'he');
        setFormData(prev => ({
            ...prev,
            language: i18n.language || 'he'
        }));
    }, [i18n.language]);
    // const [documents, setDocuments] = useState([]);
    const [withholdingTaxRowAdded, setWithholdingTaxRowAdded] = useState(false);
    /** When true, invoiceWithholdingTax is kept in sync with receipt total × client deductionRate */
    const [autoClientWithholding, setAutoClientWithholding] = useState(false);
    const [withholdingPercent, setWithholdingPercent] = useState('');
    const [updateLedger, setUpdateLedger] = useState(false);


    // const handleDocumentUpload = (event) => {
    //     const selectedFiles = Array.from(event.target.files);
    //     setDocuments(selectedFiles);
    // };

    const handleTaxAuthorityAuth = (authUrl) => {
        // Open the authentication URL in a new tab

        const authWindow = window.open(authUrl, '_blank');

        // Store the authWindow in state
        setAuthWindow(authWindow);

        // Start checking for authentication completion
        checkAuthCompletion(authWindow);
    };
    const [formData, setFormData] = useState({
        invoiceClientName: '',
        invoiceClientCaseId: '',
        invoiceAccountCodeId: '',
        invoiceClientEmail: '',
        invoiceClientPhoneNumber: '',
        invoiceClientLocation: '',
        invoiceDescription: '',
        sendToCreator: false,
        priceIncludingVAT: true,
        invoiceDate: (() => {
            // Get Israel time (Asia/Jerusalem), then convert to UTC
            const israelDate = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Jerusalem" }));
            return new Date(Date.UTC(
                israelDate.getFullYear(),
                israelDate.getMonth(),
                israelDate.getDate(),
                israelDate.getHours(),
                israelDate.getMinutes(),
                israelDate.getSeconds(),
                israelDate.getMilliseconds()
            ));
        })(),
        reportingMonthDate: (() => {
            const israelDate = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Jerusalem" }));
            return new Date(Date.UTC(
                israelDate.getFullYear(),
                israelDate.getMonth(),
                israelDate.getDate(),
                israelDate.getHours(),
                israelDate.getMinutes(),
                israelDate.getSeconds(),
                israelDate.getMilliseconds()
            ));
        })(),
        invoiceItems: [],
        receiptItems: {
            checks: [],
            creditCards: [],
            cash: [],
            bankTransactions: [],
            offsets: [],
        },
        documents: [],
        forceNoTax: false,
        noNeedforConfirmationNumber: false,
        language: i18n.language || 'he', // Default to current UI language
    });

    const [VAT_RATE, setVatRate] = useState(getVatValue(formData?.invoiceDate));
    useEffect(() => {
        if (formData?.invoiceDate) {
            setVatRate(getVatValue(formData.invoiceDate));
        }
    }, [formData]);

    const isTaxExemptOrNoTax = useMemo(() => {
        if (!client) return false;
        const clientIsExempt = client?.caseType && Constants.TaxExemptTypes.includes(client.caseType);
        return formData.forceNoTax || clientIsExempt;
    }, [formData.forceNoTax, client]);


    const showNoTaxCheckbox = useMemo(() => {
        if (!client) return false;
        // Don't show Tax Options for regular receipts (invoiceModalType === 6)
        if (invoiceModalType === 6) return false;
        const clientIsExempt = client?.caseType && Constants.TaxExemptTypes.includes(client.caseType);
        return (invoiceModalType === 5) || clientIsExempt;
    }, [invoiceModalType, client]);

    // Compute the total invoice amount (skipping VAT if isTaxExemptOrNoTax)
    const computeTotalInvoiceAmount = () => {
        if (!client || !client.caseType) {
            return 0;
        }
        
        const isTaxExemptOrNoTax = Constants.TaxExemptTypes.includes(client.caseType) || formData.forceNoTax;
        
        if (formData.foreignCurrencyCode != null) {
            return formData.invoiceItems.reduce((sum, item) => {
                const price = parseFloat(item.price) || 0;
                const quantity = parseFloat(item.quantity) || 1;
                const discountPercent = parseFloat(item.discount) || 0;
                let baseAmount = price * quantity;
                let discountedPrice = baseAmount - (baseAmount * discountPercent) / 100;
                
                // Check if this specific item should include VAT
                const itemIncludeVat = item.includeVat !== undefined ? item.includeVat : true;
                
                if (formData.priceIncludingVAT) {
                    return sum + discountedPrice;
                } else {
                    return sum + (discountedPrice * (1 + VAT_RATE));
                }
            }, 0);
        }
        
        return formData.invoiceItems.reduce((sum, item) => {
            let price = parseFloat(item.price) || 0;
            const quantity = parseFloat(item.quantity) || 1;
            const discountPercent = parseFloat(item.discount) || 0;
            let baseAmount = price * quantity;
            let discountedPrice = baseAmount - (baseAmount * discountPercent) / 100;
            
            if (isTaxExemptOrNoTax) {
                return sum + discountedPrice;
            } else {
                // Check if this specific item should include VAT
                const itemIncludeVat = item.includeVat !== undefined ? item.includeVat : true;
                
                if (formData.priceIncludingVAT) {
                    // Global setting is PriceIncludingVAT
                    if (itemIncludeVat) {
                        // Item also has VATCalculation - price already includes VAT
                        return sum + discountedPrice;
                    } else {
                        // Item has NoVATCalculation - price includes VAT but we don't want to calculate VAT for this item
                        // So we return the price as is (it's already the final amount)
                        return sum + discountedPrice;
                    }
                } else {
                    // Global setting is PriceExcludingVAT
                    if (itemIncludeVat) {
                        // Item has VATCalculation - add VAT to the price
                        return sum + (discountedPrice * (1 + VAT_RATE));
                    } else {
                        // Item has NoVATCalculation - price is without VAT and we don't add VAT
                        return sum + discountedPrice;
                    }
                }
            }
        }, 0);
    };
    const totalReceiptAmount = useMemo(() => {
        const { checks, creditCards, cash, bankTransactions, offsets } = formData.receiptItems;
        const sumAmounts = (items) => {
            return (items || []).reduce((partial, i) => partial + (parseFloat(i.amount) || 0), 0);
        };
        return (
            sumAmounts(checks) +
            sumAmounts(creditCards) +
            sumAmounts(cash) +
            sumAmounts(bankTransactions) +
            sumAmounts(offsets) +
            parseFloat(formData.invoiceWithholdingTax || 0)
        );
    }, [formData.receiptItems.checks, formData.receiptItems.creditCards, formData.receiptItems.cash, formData.receiptItems.bankTransactions, formData.receiptItems.offsets, formData.invoiceWithholdingTax]);

    const totalInvoiceAmount = useMemo(() => computeTotalInvoiceAmount(), [
        formData.invoiceItems,
        formData.priceIncludingVAT,
        formData.forceNoTax,
        formData.foreignCurrencyCode,
        client?.caseType,
        VAT_RATE
    ]);

    // "שיוך מסמכים" (create mode): existing documents the new receipt will be linked to.
    // InvoiceReceipt (type 5) uses the items-table total; a plain Receipt (type 6) uses the
    // payment methods total. The backend then decides PaymentFor vs GeneratedFrom from case type.
    const receiptLinkingItems = useMemo(
        () => (invoiceModalType === 5 ? toLinkDraftItems(formData.invoiceItems) : []),
        [invoiceModalType, formData.invoiceItems]
    );
    const receiptLinking = useDocumentLinking({
        entityType: ENTITY_TYPE.PAYMENT_ACCEPTANCE,
        documentType: invoiceModalType === 5 ? 6 /* InvoiceReceipt */ : 7 /* Receipt */,
        customerAccountCodeId: formData.invoiceAccountCodeId ? String(formData.invoiceAccountCodeId) : '',
        customerName: formData.invoiceClientName,
        amount: invoiceModalType === 5 ? totalInvoiceAmount : totalReceiptAmount,
        currency: formData.foreignCurrencyCode === 0 || formData.foreignCurrencyCode
            ? formData.foreignCurrencyCode
            : CURRENCY_ILS,
        items: receiptLinkingItems,
        enabled: invoiceModalType === 5 || invoiceModalType === 6,
    });

    const linkedDocumentDescription = () =>
        pendingLinksToLinkedDescription(
            receiptLinking.pendingLinks,
            (type) => Constants.TransactionDocuments?.[type],
            t('Document')
        );
    
    
    // Check if complex VAT logic is needed (when items have different VAT settings)
    const needsComplexVatLogic = () => {
        // If forceNoTax is true, no complex VAT logic is needed
        if (formData.forceNoTax) {
            return false;
        }
        
        if (!formData.invoiceItems || formData.invoiceItems.length === 0) {
            return false;
        }
        
        // Check if all items have the same VAT setting
        const firstItemVatSetting = formData.invoiceItems[0]?.includeVat !== undefined 
            ? formData.invoiceItems[0].includeVat 
            : true;
            
        const allItemsHaveSameVatSetting = formData.invoiceItems.every(item => {
            const itemVatSetting = item.includeVat !== undefined ? item.includeVat : true;
            return itemVatSetting === firstItemVatSetting;
        });
        
        // If all items have the same VAT setting, no complex logic is needed
        if (allItemsHaveSameVatSetting) {
            return false;
        }
        
        // Check if any item has a different VAT setting than the global setting
        const globalVatSetting = formData.priceIncludingVAT;
        return formData.invoiceItems.some(item => {
            const itemVatSetting = item.includeVat !== undefined ? item.includeVat : true;
            return itemVatSetting !== globalVatSetting;
        });
    };
    
    // Check if all items have NoVATCalculation (includeVat = false)
    const allItemsHaveNoVATCalculation = () => {
        if (!formData.invoiceItems || formData.invoiceItems.length === 0) {
            return false;
        }
        
        return formData.invoiceItems.every(item => {
            const itemVatSetting = item.includeVat !== undefined ? item.includeVat : true;
            return itemVatSetting === false; // NoVATCalculation
        });
    };

    // Function to calculate total VAT amount for display
    const computeTotalVATAmount = () => {
        if (!client || !client.caseType) {
            return 0;
        }
        
        const isTaxExemptOrNoTax = Constants.TaxExemptTypes.includes(client.caseType) || formData.forceNoTax;
        
        if (isTaxExemptOrNoTax) {
            return 0;
        }
        
        return formData.invoiceItems.reduce((sum, item) => {
            let price = parseFloat(item.price) || 0;
            const quantity = parseFloat(item.quantity) || 1;
            const discountPercent = parseFloat(item.discount) || 0;
            let baseAmount = price * quantity;
            let discountedPrice = baseAmount - (baseAmount * discountPercent) / 100;
            
            // Check if this specific item should include VAT
            const itemIncludeVat = item.includeVat !== undefined ? item.includeVat : true;
            
            if (!itemIncludeVat) {
                // Item has NoVATCalculation - no VAT for this item
                return sum;
            }
            
            if (formData.priceIncludingVAT) {
                // Global setting is PriceIncludingVAT
                // Extract VAT from the price (price includes VAT)
                const priceWithoutVAT = discountedPrice / (1 + VAT_RATE);
                const itemVAT = discountedPrice - priceWithoutVAT;
                return sum + itemVAT;
            } else {
                // Global setting is PriceExcludingVAT
                // Calculate VAT on top of the price
                const itemVAT = discountedPrice * VAT_RATE;
                return sum + itemVAT;
            }
        }, 0);
    };
    
    // Function to calculate total amount without VAT for display
    const computeTotalAmountWithoutVAT = () => {
        if (!client || !client.caseType) {
            return 0;
        }
        
        const isTaxExemptOrNoTax = Constants.TaxExemptTypes.includes(client.caseType) || formData.forceNoTax;
        
        if (isTaxExemptOrNoTax) {
            return totalInvoiceAmount;
        }
        
        return formData.invoiceItems.reduce((sum, item) => {
            let price = parseFloat(item.price) || 0;
            const quantity = parseFloat(item.quantity) || 1;
            const discountPercent = parseFloat(item.discount) || 0;
            let baseAmount = price * quantity;
            let discountedPrice = baseAmount - (baseAmount * discountPercent) / 100;
            
            // Check if this specific item should include VAT
            const itemIncludeVat = item.includeVat !== undefined ? item.includeVat : true;
            
            if (!itemIncludeVat) {
                // Item has NoVATCalculation - include the full amount in "without VAT" total
                return sum + discountedPrice;
            }
            
            if (formData.priceIncludingVAT) {
                // Global setting is PriceIncludingVAT
                // Extract price without VAT
                const priceWithoutVAT = discountedPrice / (1 + VAT_RATE);
                return sum + priceWithoutVAT;
            } else {
                // Global setting is PriceExcludingVAT
                // Price is already without VAT
                return sum + discountedPrice;
            }
        }, 0);
    };
    
    const totalVATAmount = useMemo(() => computeTotalVATAmount(), [
        formData.invoiceItems,
        formData.priceIncludingVAT,
        formData.forceNoTax,
        client?.caseType,
        VAT_RATE
    ]);
    
    const totalAmountWithoutVAT = useMemo(() => computeTotalAmountWithoutVAT(), [
        formData.invoiceItems,
        formData.priceIncludingVAT,
        formData.forceNoTax,
        client?.caseType,
        VAT_RATE,
        totalInvoiceAmount
    ]);
    
    // The limit is evaluated on the amount before VAT, so it matches the threshold
    // the tax authority applies when requiring a confirmation number.
    const [isAmountAboveLimit, setIsAmountAboveLimit] = useState(totalAmountWithoutVAT >= getIsraelInvoiceAmountLimit(formData.invoiceDate));
    useEffect(() => {
        if (formData?.invoiceDate) {
            setIsAmountAboveLimit(totalAmountWithoutVAT >= getIsraelInvoiceAmountLimit(formData?.invoiceDate));
        }
    }, [formData, totalAmountWithoutVAT]);


    // 1) Basic fields check
    const basicFieldsFilled = useMemo(() => {
        return (
            formData.invoiceClientName &&
            formData.reportingMonthDate &&
            formData.invoiceDate
        );
    }, [
        formData.invoiceClientName,
        formData.reportingMonthDate,
        formData.invoiceDate,
    ]);

    // 2) Check invoice items (if needed)
    const invoiceItemsValid = useMemo(() => {
        // If we do NOT need to check invoice items (i.e. modalType = 6 only?),
        // we can just return true to avoid failing the overall condition.
        // But here, we DO check invoice items for modalType === 5 or "other" (not 6).
        // So let's check them whenever "invoiceModalType !== 6" is relevant.
        // We'll do a narrower check below to handle "5" vs. "others."

        // If we need to validate them:
        const hasItems = formData.invoiceItems.length > 0;
        const allFields = formData.invoiceItems.every(item =>
            item.name &&
            item.makat &&
            item.price !== null &&
            item.price !== undefined
        );

        return hasItems && allFields;
    }, [formData.invoiceItems]);

    // 3) Check receipt items (if needed)
    // (ALL sub-arrays must have valid amount and paymentDate)
    const receiptItemsValid = useMemo(() => {
        const { checks = [], creditCards = [], cash = [], bankTransactions = [], offsets = [] } = formData.receiptItems ?? {};

        // If all payment methods are empty, consider it invalid
        const allEmpty =
            checks.length === 0 &&
            creditCards.length === 0 &&
            cash.length === 0 &&
            bankTransactions.length === 0 &&
            offsets.length === 0;

        if (allEmpty) return false;

        const isValid = (items, requireDescription = false) =>
            items.every(item =>
                item.amount &&
                item.amount !== null &&
                item.amount !== undefined &&
                item.paymentDate &&
                item.paymentDate !== null &&
                item.paymentDate !== undefined &&
                (!requireDescription || (item.description && item.description.trim() !== ''))
            );

        return (
            isValid(checks, true) &&         // ✅ require description for checks
            isValid(creditCards) &&
            isValid(cash) &&
            isValid(bankTransactions) &&
            isValid(offsets)
        );
    }, [
        formData.receiptItems?.checks,
        formData.receiptItems?.creditCards,
        formData.receiptItems?.cash,
        formData.receiptItems?.bankTransactions,
        formData.receiptItems?.offsets,
    ]);


    // 4) Amount-above-limit check
    const clientCaseIdCheck = useMemo(() => {
        return (!isAmountAboveLimit || isValidShaamCustomerVatNumber(formData.invoiceClientCaseId) || formData.noNeedforConfirmationNumber);
    }, [isAmountAboveLimit, formData.invoiceClientCaseId, formData.noNeedforConfirmationNumber]);

    // Combine it all into one final condition
    const allClientItemFieldsFilled = useMemo(() => {
        // Must have the basic fields
        if (!basicFieldsFilled) return false;
        // Must pass the amount limit check
        if (!clientCaseIdCheck) return false;

        // Ensure phone number is valid
        if (!validatePhoneNumber(formData.invoiceClientPhoneNumber)) return false;

        // Ensure email is valid only if it's entered
        if ((formData.invoiceClientEmail) && !validateEmail(formData.invoiceClientEmail)) return false;

        // Logic for invoiceModalType
        switch (invoiceModalType) {
            case 5:
                // Must validate *both* invoiceItems + receiptItems
                if (!invoiceItemsValid || !receiptItemsValid) return false;
                // Additional check for discount validity
                if (formData.invoiceItems.some(it => (
                    it.discount === null ||
                    it.discount === undefined ||
                    it.discount === '' ||
                    isNaN(it.discount) ||
                    it.discount < 0 ||
                    it.discount > 100
                ))) return false;
                return true;
            case 6:
                // Must validate *only* receiptItems
                return receiptItemsValid;
            default:
                // For any other modalType, must validate only invoiceItems
                if (!invoiceItemsValid) return false;
                if (formData.invoiceItems.some(it => (
                    it.discount === null ||
                    it.discount === undefined ||
                    it.discount === '' ||
                    isNaN(it.discount) ||
                    it.discount < 0 ||
                    it.discount > 100
                ))) return false;
                return true;
        }
    }, [
        formData,
        basicFieldsFilled,
        clientCaseIdCheck,
        invoiceModalType,
        invoiceItemsValid,
        receiptItemsValid,
    ]);


    const handleReceiptItemChange = (type, index, field, value) => {


        setFormData((prevState) => {
            const updatedItems = [...prevState.receiptItems[type]];
            updatedItems[index] = {
                ...updatedItems[index],
                [field]: value,
            };
            return {
                ...prevState,
                receiptItems: {
                    ...prevState.receiptItems,
                    [type]: updatedItems,
                },
            };
        });
    };

    const handleAddReceiptItem = (type) => {
        setFormData((prevState) => {
            const newItem = { amount: '', description: '', documentFile: null, documentUrl: '' };

            if (isBankPaymentType(type)) {
                Object.assign(newItem, getCardBankDetails(findAccountCardById(prevState.invoiceAccountCodeId)));
            }
            
            // If adding a check, auto-increment the check number
            if (type === 'checks' && prevState.receiptItems[type] && prevState.receiptItems[type].length > 0) {
                // Get the previous check item (first item in the array since new items are prepended)
                const previousCheck = prevState.receiptItems[type][0];
                const previousCheckNumber = previousCheck?.description || '';
                
                if (previousCheckNumber) {
                    // Extract numeric part from the check number
                    // Handle formats like "123", "12345", "CHK-123", etc.
                    const numericMatch = previousCheckNumber.match(/\d+/);
                    if (numericMatch) {
                        const previousNumber = parseInt(numericMatch[0], 10);
                        if (!isNaN(previousNumber)) {
                            const nextNumber = previousNumber + 1;
                            // Preserve any non-numeric prefix/suffix if present
                            const prefix = previousCheckNumber.substring(0, numericMatch.index);
                            const suffix = previousCheckNumber.substring(numericMatch.index + numericMatch[0].length);
                            newItem.description = prefix + nextNumber + suffix;
                        } else {
                            newItem.description = previousCheckNumber + '1'; // Fallback: append 1
                        }
                    } else {
                        // If no number found, just append "1"
                        newItem.description = previousCheckNumber + '1';
                    }
                }
            }
            
            return {
                ...prevState,
                receiptItems: {
                    ...prevState.receiptItems,
                    [type]: [newItem, ...prevState.receiptItems[type]], // Prepend the new item
                },
            };
        });
    };


    const handleRemoveReceiptItem = (type, index) => {
        setFormData((prevState) => {
            const updatedItems = prevState.receiptItems[type].filter((item, idx) => idx !== index);
            return {
                ...prevState,
                receiptItems: {
                    ...prevState.receiptItems,
                    [type]: updatedItems,
                },
            };
        });
    };

    // Handle file upload for specific payment method item
    const handleReceiptItemFileUpload = (type, index, event) => {
        const file = event.target.files[0];
        if (file) {
            setFormData((prevState) => {
                const updatedItems = [...prevState.receiptItems[type]];
                updatedItems[index] = {
                    ...updatedItems[index],
                    documentFile: file,
                    documentUrl: URL.createObjectURL(file) // For preview
                };
                return {
                    ...prevState,
                    receiptItems: {
                        ...prevState.receiptItems,
                        [type]: updatedItems,
                    },
                };
            });
        }
    };

    // Remove file from specific payment method item
    const handleReceiptItemFileRemove = (type, index) => {
        setFormData((prevState) => {
            const updatedItems = [...prevState.receiptItems[type]];
            updatedItems[index] = {
                ...updatedItems[index],
                documentFile: null,
                documentUrl: ''
            };
            return {
                ...prevState,
                receiptItems: {
                    ...prevState.receiptItems,
                    [type]: updatedItems,
                },
            };
        });
    };

    const handleSignatureChange = () => {
        if (sigPad.current) {
            setInvoiceSignature(sigPad.current.getTrimmedCanvas().toDataURL('image/png'));
            setSignatureReferenceFilled(invoiceSignature && invoiceReference);
        }
    };

    const handleSignatureReferenceSave = async () => {
        if (needSignature && !invoiceSignature) {
            toast.error(t('ProvideSignature'));
            return;
        }
        if (needReference && !invoiceReference) {
            toast.error(t('ProvideSignature'));
            return;
        }

        // TaxInvoice and InvoiceReceipt (ReceiptTax) share the same invoice numbering
        // series, so their reference numbers must be at least 1000 apart. This is only
        // enforced against a sibling that has actually been customized (not its default).
        if (needReference && invoiceReference) {
            const refKey = getReferenceKeyAndDefault(invoiceModalType)?.key;
            const siblingInfo =
                refKey === 'taxInvoiceReference'
                    ? { key: 'recieptTaxReference', default: 1000, messageKey: 'ReceiptInvoiceReferenceMustBeApart' }
                    : refKey === 'recieptTaxReference'
                        ? { key: 'taxInvoiceReference', default: 0, messageKey: 'InvoiceReferenceMustBeApart' }
                        : null;
            if (siblingInfo) {
                const enteredValue = parseInt(invoiceReference, 10);
                try {
                    const referencesResponse = await DocumentService.GetReferenceByCaseId(client.caseId, token);
                    const siblingValue = parseInt(referencesResponse?.data?.[siblingInfo.key], 10);
                    const siblingCustomized = !isNaN(siblingValue) && siblingValue !== siblingInfo.default;
                    if (siblingCustomized && !isNaN(enteredValue) && Math.abs(enteredValue - siblingValue) < 1000) {
                        toast.error(t(siblingInfo.messageKey, { current: siblingValue, recommended: siblingValue + 1000 }));
                        return;
                    }
                } catch (error) {
                    console.error('Error validating reference gap:', error);
                }
            }
        }

        setSignatureReferenceInvoiceModalVisible(false);
        // Proceed with next steps
    };

    const handleSignatureReferenceClose = async () => {
        setInvoiceSignature('');
        setInvoiceReference('');
        setSignatureReferenceInvoiceModalVisible(false);
    };

    const clearSignature = () => {
        sigPad.current.clear();
        setInvoiceSignature('');
        setSignatureReferenceFilled(false);
    };

    useEffect(() => {

        setFormData((prevFormData) => ({
            ...prevFormData,
            documents: files,

        }));
    }, [files]);




    const dataURLtoFile = (dataurl, filename) => {
        const arr = dataurl.split(',');
        const mimeMatch = arr[0].match(/:(.*?);/);
        const mime = mimeMatch ? mimeMatch[1] : '';
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    };


    useEffect(() => {
        const fetchUserData = async () => {
            setIsInitializing(true);
            setLoading(true);
            try {
                const currentUser = await UserService.getCurrentUser();
                const currentToken = await UserService.getCurrentToken();
                if (currentUser && currentToken) {
                    setUser(currentUser);
                    setToken(currentToken);

                    if (location.state && location.state.client && location.state.type) {
                        setClient(location.state.client);
                        setType(location.state.type);

                        // Refetch client data to get the latest information
                        try {
                            const updatedClient = await ClientService.GetClient(currentToken, location.state.client.caseId);
                            setClient(updatedClient);
                        } catch (error) {
                            console.error('Error refetching client data:', error);
                        }

                        // Map the location.state.type to the correct invoiceModalType index
                        const typeMapping = {
                            'TaxInvoice': Constants.TransactionDocumentsNames.taxInvoice,
                            'CreditNote': Constants.TransactionDocumentsNames.creditInvoice,
                            'Quotation': Constants.TransactionDocumentsNames.quotation,
                            'Order': Constants.TransactionDocumentsNames.order,
                            'TransactionInvoice': Constants.TransactionDocumentsNames.transaction,
                            'ReceiptTax': Constants.TransactionDocumentsNames.taxInvoiceReceipt,
                            'Receipt': Constants.TransactionDocumentsNames.receipt,
                        };
                        // Handle the item passed in location.state.item (could be duplicate or from receipt)
                        if (location.state.item) {
                            const itemData = location.state.item;
                            const documents = itemData.documents || [];
                            
                            // Check if this is a duplicate action (from TransactionDocuments)
                            const isDuplicate = !itemData.filePaymentMethodMapping && itemData.items;
                            
                            if (isDuplicate) {
                                // Handle duplicate transaction document
                                
                                // Wait a bit for accountCardOptions to be populated
                                setTimeout(() => {
                                    // Find the matching account card to get email, phone, location
                                    const matchingAccountCard = accountCardEditDownloadOptions.find(
                                        option => option.cardId?.toString() === itemData.accountCodeId?.toString()
                                    );
                                    
                                    
                                    setFormData((prevFormData) => ({
                                        ...prevFormData,
                                        invoiceClientName: itemData.accountCodeName || '',
                                        invoiceClientCaseId: itemData.accountCaseId || '',
                                        invoiceAccountCodeId: itemData.accountCodeId ? parseInt(itemData.accountCodeId, 10) : '',
                                        invoiceClientEmail: matchingAccountCard?.email || '',
                                        invoiceClientPhoneNumber: matchingAccountCard?.phoneNumber || '',
                                        invoiceClientLocation: matchingAccountCard?.location || '',
                                        invoiceDescription: itemData.description || '',
                                        invoiceDate: itemData.documentDate ? new Date(itemData.documentDate) : new Date(),
                                        reportingMonthDate: itemData.reportingMonthDate || itemData.documentDate ? new Date(itemData.reportingMonthDate || itemData.documentDate) : new Date(),
                                        priceIncludingVAT: itemData.priceIncludingVAT !== undefined ? itemData.priceIncludingVAT : true,
                                        forceNoTax: itemData.vat === 0 ? true : (itemData.forceNoTax || false),
                                        foreignCurrencyCode: itemData.foreignCurrencyCode || null,
                                        invoiceItems: itemData.items?.map(item => ({
                                            makat: item.makat || '',
                                            name: item.name || '',
                                            quantity: item.quantity || 1,
                                            price: item.price || 0,
                                            discount: item.discount || 0,
                                            itemId: item.itemId || item.id,
                                            isNew: !item.makat, // If no makat, it's a new item that needs to be created
                                            includeVat: item.includeVat !== undefined ? item.includeVat : true,
                                        })) || [],
                                    }));
                                    
                                }, 100);
                            } else {
                                // Parse FilePaymentMethodMapping if available (original receipt handling)
                                let fileMapping = [];
                                if (itemData.filePaymentMethodMapping) {
                                    try {
                                        fileMapping = typeof itemData.filePaymentMethodMapping === 'string'
                                            ? JSON.parse(itemData.filePaymentMethodMapping)
                                            : itemData.filePaymentMethodMapping;
                                    } catch (error) {
                                        console.error('Error parsing FilePaymentMethodMapping:', error);
                                    }
                                }

                                // Use documents as-is when already File objects (e.g. from PaymentAcceptance receipt flow);
                                // otherwise build File from metadata (contentType/fileName)
                                const rawDocs = itemData.documents || [];
                                const validDocuments = rawDocs.length > 0 && rawDocs[0] instanceof File
                                    ? rawDocs
                                    : rawDocs.map((doc) => {
                                        try {
                                            return new File(
                                                [doc.contentType ?? doc.content ?? ''],
                                                doc.fileName ?? doc.name ?? 'document',
                                                { type: doc.contentType || doc.type || 'application/octet-stream', lastModified: Date.now() }
                                            );
                                        } catch (error) {
                                            console.error('Error creating File object:', error);
                                            return null;
                                        }
                                    }).filter(Boolean);

                                // Helper to assign documents to payment method items based on mapping.
                                // When we have more items than files (e.g. one PDF with many pages), each check still gets a document (same file for all).
                                const assignDocumentsToPaymentMethods = (paymentMethodItems, paymentMethodType, docs) => {
                                    if (!paymentMethodItems || paymentMethodItems.length === 0) return paymentMethodItems;
                                    if (!docs || docs.length === 0) return paymentMethodItems;
                                    
                                    const mappedFiles = fileMapping
                                        .filter(m => m.paymentMethodType?.toLowerCase() === paymentMethodType.toLowerCase())
                                        .map(m => m.fileIndex);
                                    
                                    return paymentMethodItems.map((item, index) => {
                                        // One document per item when we have separate files; when more items than mapped indices (e.g. one multi-page PDF), use same doc
                                        const fileIndex = index < mappedFiles.length
                                            ? mappedFiles[index]
                                            : (index % docs.length);
                                        if (fileIndex < docs.length) {
                                            return {
                                                ...item,
                                                documentFile: docs[fileIndex],
                                                documentUrl: docs[fileIndex] instanceof File ? URL.createObjectURL(docs[fileIndex]) : (item.documentUrl || '')
                                            };
                                        }
                                        return item;
                                    });
                                };

                                // Process receipt items with document assignments (handles multiple checks, creditCards, etc.)
                                const receiptItems = {
                                    checks: assignDocumentsToPaymentMethods(itemData.checks || [], 'checks', validDocuments),
                                    creditCards: assignDocumentsToPaymentMethods(itemData.creditCards || [], 'creditcards', validDocuments),
                                    cash: assignDocumentsToPaymentMethods(itemData.cash || [], 'cash', validDocuments),
                                    bankTransactions: assignDocumentsToPaymentMethods(itemData.bankTransactions || [], 'banktransactions', validDocuments),
                                    offsets: assignDocumentsToPaymentMethods(itemData.offsets || [], 'offsets', validDocuments),
                                };

                                // Update formData with the constructed documents
                                setFormData((prevFormData) => ({
                                    ...prevFormData,
                                    base64Files: itemData.base64Files,
                                    documents: validDocuments,
                                    invoiceClientName: itemData.accountCodeName || '',
                                    invoiceClientCaseId: itemData.accountCaseId || '',
                                    invoiceAccountCodeId: itemData.accountCodeId || '',
                                    invoiceDescription: itemData.description || '',
                                    invoiceDate: itemData.date ? new Date(itemData.date) : new Date(),
                                    reportingMonthDate: itemData.reportingMonthDate ? new Date(itemData.reportingMonthDate) : new Date(),
                                    receiptItems: receiptItems,
                                }));
                            }
                        }

                        // Handle the item from ledger passed in location.state.item
                        if (location.state.itemFromLedger) {
                            const { description = '', amount = '', paymentType } = location.state.itemFromLedger;

                            // prepare empty buckets
                            const receiptItems = {
                                checks: [],
                                creditCards: [],
                                cash: [],
                                bankTransactions: [],
                                offsets: []
                            };

                            // the single row we want to insert
                            const row = { amount, description, paymentDate: new Date() };

                            // map PaymentType → bucket
                            switch (paymentType) {
                                case 0: receiptItems.creditCards.push(row); break; // Credit-card
                                case 1: receiptItems.checks.push(row); break; // Check
                                case 2: receiptItems.bankTransactions.push(row); break; // Bank-transfer
                                case 3: receiptItems.cash.push(row); break; // Cash
                                case 4: receiptItems.offsets.push(row); break; // Offset
                                default: console.warn('Unknown paymentType:', paymentType);
                            }

                            // finally update the form
                            setFormData(prevFormData => ({
                                ...prevFormData,

                                invoiceDescription: description, // what the user typed in CollectionPage
                                invoiceItems: [],                // start empty – user can add later
                                receiptItems,                    // buckets filled as above

                                // dates: keep previous or just set to "now"
                                invoiceDate: new Date(),
                                reportingMonthDate: new Date(),
                            }));
                        }

                        const modalTypeIndex = typeMapping[location.state.type];

                        if (modalTypeIndex !== undefined) {
                            setInvoiceModalType(modalTypeIndex);
                        } else {
                            // Handle unknown type, maybe set a default or show an error
                            console.error('Unknown invoice type:', location.state.type);
                            // You can set a default or handle it as needed
                            setInvoiceModalType(0); // Default to 'taxInvoice' if unknown
                        }

                        await fetchEnums(currentUser, currentToken, location.state.client);
                    }
                } else {
                    navigate('/login');
                }
            } catch (error) {
                // Handle error - maybe navigate to login or show a message
                console.error('Error fetching user data:', error);
                toast.error(t('ErrorLoadingData'));
            } finally {
                setLoading(false);
                setIsInitializing(false);
            }
        };

        fetchUserData();
        // Include dependencies in the dependency array
    }, [location.state.client, location.state.type]);

    useEffect(() => {
        // Update direction based on the current language
        if (i18n.language === 'he' || i18n.language === 'ar') {
            setDirection('rtl');
        } else {
            setDirection('ltr');
        }
    }, [i18n.language]);

    const fetchEnums = async (user, token, client) => {
        setLoading(true);
        try {
            const [codeIdResponse, accountsResponse, clientItemsResponse] = await Promise.all([
                EnumsService.GetSortCodesByAccountantId(client.accountantId, token),
                EnumsService.GetAccountCardsByCaseId(client.caseId, token),
                EnumsService.GetClientItemsByCaseId(client.caseId, token),
            ]);

            if (codeIdResponse.ok) {
                const codeIdData = await codeIdResponse.json();
                setSortCodeIdOptions(codeIdData);
            }

            if (accountsResponse.ok) {
                const accountsData = await accountsResponse.json();
                setCreditAccountOptions(accountsData);
                setDebitAccountOptions(accountsData);
                setAccountCardEditDownloadOptions(accountsData);
                const accountCardOptions = [{ name: t('addCustomer'), value1: 'AddItem', isEditable: true }, ...accountsData];

                setAccountCardOptions(accountCardOptions);
            }

            if (clientItemsResponse.ok) {
                const clientItemsData = await clientItemsResponse.json();
                // clientItemsData.unshift({ makat: 'add-item', name: t('AddItem') });
                setClientItems(clientItemsData);

                // Pre-fill invoice items table with default item if set and table is empty
                const defaultItem = Array.isArray(clientItemsData) ? clientItemsData.find(i => i.isDefaultItem === true) : null;
                if (defaultItem && (defaultItem.makat || defaultItem.Makat)) {
                    setFormData(prev => {
                        if (prev.invoiceItems && prev.invoiceItems.length > 0) return prev;
                        const row = {
                            makat: defaultItem.makat ?? defaultItem.Makat ?? '',
                            name: defaultItem.name ?? defaultItem.Name ?? '',
                            quantity: 1,
                            price: defaultItem.price ?? defaultItem.Price ?? '',
                            discount: 0,
                            isNew: false,
                            includeVat: defaultItem.includeVat ?? defaultItem.IncludeVat ?? true,
                            itemId: defaultItem.id ?? defaultItem.Id ?? null
                        };
                        return { ...prev, invoiceItems: [row] };
                    });
                    setAddItemFlags([true]);
                }
            }

            setIsFirstUserFetched(true);

            // Load current inventory stock levels (by ClientItem id) so we can warn on over-selling
            if (client?.managesInventory) {
                try {
                    const invResp = await InventoryService.GetInventoryItemsWithClientItemByCaseId(
                        client.caseId,
                        null,
                        token,
                    );
                    if (invResp.ok) {
                        const { success, data } = await invResp.json();
                        if (success && Array.isArray(data)) {
                            const map = {};
                            data.forEach((it) => {
                                if (it.clientItemId) {
                                    map[it.clientItemId] = Number(it.currentQuantity) || 0;
                                }
                            });
                            setInventoryStockByItemId(map);
                        }
                    }
                } catch (err) {
                    console.error('Error fetching inventory stock for receipt:', err);
                }
            }

            try {
                const projectsRes = await ProjectsService.getProjects(client.caseId, token);
                if (projectsRes.ok) {
                    const projectsData = await projectsRes.json();
                    setSegmentationProjects(Array.isArray(projectsData) ? projectsData : []);
                }
            } catch (err) {
                console.error('Error fetching segmentations for receipt:', err);
            }
        } catch (error) {
            console.error('Error fetching enum data:', error);
            toast.error(t('enumFetchError', { errorText: error.message }));
        } finally {
            setLoading(false);
        }
    };

    const refreshSegmentationProjects = useCallback(async () => {
        if (!client?.caseId || !token) return;
        try {
            const projectsRes = await ProjectsService.getProjects(client.caseId, token);
            if (projectsRes.ok) {
                const projectsData = await projectsRes.json();
                setSegmentationProjects(Array.isArray(projectsData) ? projectsData : []);
            }
        } catch (err) {
            console.error('Error refreshing segmentations for receipt:', err);
        }
    }, [client?.caseId, token]);

    const handleCloseAddNewAccountCardDocument = () => {
        setFormData((prev) => ({
            ...prev,
            invoiceAccountCodeId: '',
            invoiceClientCaseId: '',
            invoiceClientName: '',
            invoiceClientEmail: '',
            invoiceClientPhoneNumber: '',
            invoiceClientLocation: '',
        }));
        setAddNewAccountCardDocument(false);
    };

    // useEffect(() => {
    //     if (client) {
    //         if (client?.signature && client?.invoicesNumbers) {
    //             // setInvoiceModalVisible(true); // If you have an invoice modal
    //         } else {
    //             setSignatureReferenceInvoiceModalVisible(true);
    //         }
    //     }
    // }, [client]);


    const [deferredReceipt, setDeferredReceipt] = useState(false);
    const StyledPopper = styled(Popper)(({ theme }) => ({
        '& .MuiPaper-root': {
            borderRadius: 'var(--Spacing-md, 8px)',
            background: 'var(--white, #FFF)',
            boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.32)',
        },
        '& .MuiAutocomplete-listbox': {
            padding: theme.spacing(1),
        },
        '& .MuiAutocomplete-option': {
            borderRadius: 'var(--Spacing-sm, 4px)',
            '&[aria-selected="true"], &.Mui-focused, &:hover': {
                background: 'var(--orange, #F9AA2A) !important',
            },
        },
    }));

    const handleChange = (field, value) => {
        if (field === 'invoiceWithholdingTax') {
            setAutoClientWithholding(false);
        }
        setFormData((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const recomputeDiscountPercentFromAmount = (item) => {
        const qty = parseFloat(item.quantity) || 0;
        const price = parseFloat(item.price) || 0;
        const base = qty * price;
        const amt = parseFloat(item.discountAmount);
        if (!isFinite(amt) || base <= 0) {
            return 0;
        }
        const pct = (amt / base) * 100;
        return Math.round(pct * 10000) / 10000;
    };

    const handleItemChange = (index, field, value) => {
        setFormData((prevState) => {
            const updatedItems = [...prevState.invoiceItems];
            const item = { ...updatedItems[index], [field]: value };

            if (field === 'discount') {
                delete item.discountAmount;
            } else if (
                (field === 'price' || field === 'quantity') &&
                item.discountAmount !== undefined &&
                item.discountAmount !== null &&
                item.discountAmount !== ''
            ) {
                item.discount = recomputeDiscountPercentFromAmount(item);
            }

            updatedItems[index] = item;
            return {
                ...prevState,
                invoiceItems: updatedItems,
            };
        });
    };

    const handleItemDiscountAmountChange = (index, amountStr) => {
        setFormData((prevState) => {
            const updatedItems = [...prevState.invoiceItems];
            const item = { ...updatedItems[index], discountAmount: amountStr };
            if (amountStr === '' || amountStr === null || amountStr === undefined) {
                item.discount = 0;
            } else {
                item.discount = recomputeDiscountPercentFromAmount(item);
            }
            updatedItems[index] = item;
            return { ...prevState, invoiceItems: updatedItems };
        });
    };

    const handleItemVATChange = (index, value) => {
        
        setFormData((prevState) => {
            const updatedItems = [...prevState.invoiceItems];
            const item = updatedItems[index];
            
            // Update the VAT setting
            updatedItems[index].includeVat = value;
            
            // If this is an existing item (not new), update it in the database
            if (!item.isNew && item.itemId) {
                updateClientItemVATSetting(item, value);
            }
            
            // If NoVATCalculation is selected (value is false), automatically set forceNoTax to true
            // and set all items to not include VAT
            return {
                ...prevState,
                invoiceItems: updatedItems,
            };
        });
    };

    const updateClientItemVATSetting = async (item, newVatSetting) => {
        try {
            const response = await ClientItemsService.UpdateClientItem(
                client.caseId,
                item.makat, // original makat
                item.makat, // new makat (same)
                item.name,
                item.price,
                newVatSetting, // new VAT setting
                "",
                token
            );
            
            if (!response.ok) {
                const errorText = await response.text();
                toast.error(t('FailedToUpdateClientItem') + `: ${errorText}`);
            } else {
                // Optionally show success message
                // toast.success(t('ClientItemUpdatedSuccessfully'));
            }
        } catch (error) {
            console.error('Error updating client item VAT setting:', error);
            toast.error(t('ErrorUpdatingClientItem'));
        }
    };



    const handleAddItem = () => {
        setAddItemFlags((prevFlags) => [...prevFlags, true]);
        const newItem = { 
            makat: '', 
            name: '', 
            notes: '',
            quantity: 1, 
            price: 0, 
            discount: 0, 
            isNew: true,
            includeVat: formData.forceNoTax ? false : true// Set default VAT setting based on forceNoTax or global setting
        };
        let newMakat = 1; // Default makat for the first item
        const allMakats = [
            ...clientItems.map(item => parseInt(item.makat, 10) || 0),
            ...formData.invoiceItems.map(item => parseInt(item.makat, 10) || 0)
        ];

        if (allMakats.length > 0) {
            // Find the largest makat among them
            const maxMakat = Math.max(...allMakats);
            newMakat = maxMakat + 1; // Increment the largest makat by 1
        }

        newItem.makat = newMakat.toString();
        setFormData((prevState) => ({
            ...prevState,
            invoiceItems: [...prevState.invoiceItems, newItem],
        }));
    };

    const handleRemoveItem = (index) => {
        setFormData((prevState) => {
            const updatedItems = prevState.invoiceItems.filter((item, idx) => idx !== index);
            return {
                ...prevState,
                invoiceItems: updatedItems,
            };
        });
        setAddItemFlags((prevFlags) => prevFlags.filter((flag, idx) => idx !== index));
    };


    const handleItemChangeMany = (index, updates) => {
        const discountChanged = 'discount' in updates;
        const baseChanged = 'price' in updates || 'quantity' in updates;
        setFormData(prevFormData => ({
            ...prevFormData,
            invoiceItems: prevFormData.invoiceItems.map((item, idx) => {
                if (idx !== index) return item;
                const merged = { ...item, ...updates };
                if (discountChanged) {
                    delete merged.discountAmount;
                } else if (
                    baseChanged &&
                    merged.discountAmount !== undefined &&
                    merged.discountAmount !== null &&
                    merged.discountAmount !== ''
                ) {
                    merged.discount = recomputeDiscountPercentFromAmount(merged);
                }
                return merged;
            })
        }));
    };

    const handleInvoiceItem = async (index, selectedOption) => {
        if (!selectedOption) {
            handleItemChangeMany(index, {
                makat: '',
                name: '',
                notes: '',
                price: '',
                quantity: '',
                discount: '',
                itemId: null,
                isNew: false,
                foreignCurrencyPrice: '',
            });
            const updatedFlags = [...addItemFlags];
            updatedFlags[index] = false;
            setAddItemFlags(updatedFlags);
            return;
        }
        if (selectedOption.value === 'add-item') {
            const updatedFlags = [...addItemFlags];
            updatedFlags[index] = true;
            setAddItemFlags(updatedFlags);
            let newMakat = 1;
            const allMakats = [
                ...clientItems.map(item => parseInt(item.makat, 10) || 0),
                ...formData.invoiceItems.map(item => parseInt(item.makat, 10) || 0)
            ];
            if (allMakats.length > 0) {
                const maxMakat = Math.max(...allMakats);
                newMakat = maxMakat + 1;
            }
            handleItemChangeMany(index, {
                makat: newMakat.toString(),
                name: '',
                itemId: null,
                isNew: true,
                foreignCurrencyPrice: '',
                includeVat: formData.forceNoTax ? false : true // Set default VAT setting based on forceNoTax
            });
        } else {
            let item = clientItems.find((option) => option.makat === selectedOption.value);

            let updates = {
                makat: item.makat,
                name: item.name,
                itemId: item.id,
                isNew: false,
                includeVat: formData.forceNoTax ? false : (item.includeVat !== undefined ? item.includeVat : true), // Use forceNoTax setting or item's VAT setting if available, otherwise use global setting
                quantity: itemsDisplayMode === 'descriptionOnly' ? 1 : (item.quantity || 1) // Force quantity to 1 in descriptionOnly mode
            };
            // If itemId is 0 or null and it's not a new item, fetch latest clientItems and update itemId
            if ((!item.id || item.id === 0) && !item.isNew) {
                try {
                    const clientItemsResponse = await ClientItemsService.GetClientItemsByCaseId(client.caseId, token);
                    if (clientItemsResponse.ok) {
                        const clientItemsData = await clientItemsResponse.json();
                        const found = clientItemsData.find(ci => ci.makat === item.makat);
                        if (found && found.id) {
                            updates.itemId = found.id;
                            // Optionally update clientItems state for future selections
                            setClientItems(clientItemsData);
                        }
                    }
                } catch (err) {
                    console.error('Failed to fetch latest client items for itemId update', err);
                }
            }

            const applyChosenPrice = async (chosenAmount) => {
                if (formData.foreignCurrencyCode != null && formData.invoiceDate) {
                    let rate = currencyRateValue;
                    if (!rate) {
                        rate = await ForeignCurrencyService.GetIlsRateForDate(
                            formData.foreignCurrencyCode,
                            formData.invoiceDate
                        );
                        setCurrencyRate(rate);
                    }
                    updates.foreignCurrencyPrice = chosenAmount;
                    updates.price = Number((chosenAmount * rate).toFixed(2));
                } else {
                    updates.price = chosenAmount;
                }
                handleItemChangeMany(index, updates);
                const updatedFlags = [...addItemFlags];
                updatedFlags[index] = false;
                setAddItemFlags(updatedFlags);
            };

            const selection = resolveItemPriceSelection(item);
            if (selection.needsPicker) {
                setPricePickerState({
                    index,
                    itemName: item.name,
                    prices: selection.prices,
                    apply: applyChosenPrice,
                });
                return;
            }
            await applyChosenPrice(selection.amount);
        }
    };

    const normalizeCardId = (id) => (id === null || id === undefined ? '' : String(id));

    const findAccountCardById = (id) => {
        const key = normalizeCardId(id);
        return accountCardOptions.find((option) => normalizeCardId(option.cardId ?? option.CardId) === key);
    };

    /* ------------------------------------------------------------------ */
    /* Linked invoice (Accounts Receivable) — only when the chosen client */
    /* account-card has PaymentTerms configured (the canonical column     */
    /* is `paymentTermsCustomDays`).                                       */
    /* Only meaningful for a regular Receipt (invoiceModalType === 6);    */
    /* InvoiceReceipt (5) already creates the income inline.              */
    /* ------------------------------------------------------------------ */
    const [outstandingInvoices, setOutstandingInvoices] = useState([]);
    const [isLoadingOutstandingInvoices, setIsLoadingOutstandingInvoices] = useState(false);
    const [relatedIncomeId, setRelatedIncomeId] = useState(null);
    const [relatedInvoiceReference, setRelatedInvoiceReference] = useState(null);

    const selectedReceiptCard = useMemo(
        () => findAccountCardById(formData.invoiceAccountCodeId),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [formData.invoiceAccountCodeId, accountCardOptions]
    );

    const cardHasPaymentTerms = useMemo(() => {
        const days = selectedReceiptCard?.paymentTermsCustomDays
            ?? selectedReceiptCard?.PaymentTermsCustomDays;
        return days !== null && days !== undefined && days !== '';
    }, [selectedReceiptCard]);

    const isReceiptWithLinkSupport = invoiceModalType === 6;

    useEffect(() => {
        let cancelled = false;
        const run = async () => {
            if (!isReceiptWithLinkSupport
                || !cardHasPaymentTerms
                || !client?.caseId
                || !formData.invoiceAccountCodeId
                || !token) {
                setOutstandingInvoices([]);
                return;
            }
            try {
                setIsLoadingOutstandingInvoices(true);
                const res = await ReceivablesService.GetOutstandingInvoicesForCard(
                    client.caseId,
                    String(formData.invoiceAccountCodeId),
                    token
                );
                if (!res.ok) {
                    if (!cancelled) setOutstandingInvoices([]);
                    return;
                }
                const data = await res.json();
                if (!cancelled) setOutstandingInvoices(Array.isArray(data) ? data : []);
            } catch (_) {
                if (!cancelled) setOutstandingInvoices([]);
            } finally {
                if (!cancelled) setIsLoadingOutstandingInvoices(false);
            }
        };
        run();
        return () => { cancelled = true; };
    }, [isReceiptWithLinkSupport, cardHasPaymentTerms, client?.caseId, formData.invoiceAccountCodeId, token]);

    // Reset the picked invoice when the card changes (avoid orphan link).
    useEffect(() => {
        setRelatedIncomeId(null);
        setRelatedInvoiceReference(null);
    }, [formData.invoiceAccountCodeId]);

    const linkedInvoiceValue = useMemo(() => {
        if (!cardHasPaymentTerms || !isReceiptWithLinkSupport) return null;
        if (relatedIncomeId) {
            const match = outstandingInvoices.find(o => o.id === relatedIncomeId);
            if (match) return match;
        }
        if (relatedInvoiceReference) {
            return { id: null, reference: relatedInvoiceReference };
        }
        return null;
    }, [cardHasPaymentTerms, isReceiptWithLinkSupport, relatedIncomeId, relatedInvoiceReference, outstandingInvoices]);

    const getDeductionRatePercentFromAccountCard = (accountCard) => {
        if (!accountCard) return null;
        const raw = accountCard.deductionRate ?? accountCard.DeductionRate;
        if (raw === null || raw === undefined || raw === '') return null;
        const rate = typeof raw === 'number' ? raw : parseFloat(String(raw).replace(',', '.'));
        if (!Number.isFinite(rate) || rate <= 0) return null;
        return rate;
    };

    const getReceiptAmountWithoutWithholding = () => {
        const { checks, creditCards, cash, bankTransactions, offsets } = formData.receiptItems;
        const sumAmounts = (items) => (items || []).reduce((partial, i) => partial + (parseFloat(i.amount) || 0), 0);
        return sumAmounts(checks) + sumAmounts(creditCards) + sumAmounts(cash) + sumAmounts(bankTransactions) + sumAmounts(offsets);
    };

    const receiptClientDeductionRatePercent = useMemo(() => {
        const card = findAccountCardById(formData.invoiceAccountCodeId);
        return getDeductionRatePercentFromAccountCard(card);
    }, [formData.invoiceAccountCodeId, accountCardOptions]);

    /** Payment-line total (net receipt before withholding) — used for gross-up formula */
    const totalReceiptAmountForWithholding = useMemo(
        () => getReceiptAmountWithoutWithholding(),
        [
            formData.receiptItems.checks,
            formData.receiptItems.creditCards,
            formData.receiptItems.cash,
            formData.receiptItems.bankTransactions,
            formData.receiptItems.offsets,
        ]
    );

    const resolveActiveWithholdingPercent = () => {
        if (autoClientWithholding) {
            const selectedCard = findAccountCardById(formData.invoiceAccountCodeId);
            return getDeductionRatePercentFromAccountCard(selectedCard);
        }
        if (withholdingPercent && !isNaN(Number(withholdingPercent))) {
            return Number(withholdingPercent);
        }
        return null;
    };

    const computeWithholdingAmount = (activePercent) =>
        calculateWithholdingAmount({
            modalType: invoiceModalType,
            base: totalInvoiceAmount,
            totalReceiptAmount: totalReceiptAmountForWithholding,
            activePercent,
        });

    const receiptWithholdingFormulaAmount = useMemo(() => {
        if (receiptClientDeductionRatePercent == null) {
            return 0;
        }
        return computeWithholdingAmount(receiptClientDeductionRatePercent);
    }, [
        receiptClientDeductionRatePercent,
        totalReceiptAmountForWithholding,
        totalInvoiceAmount,
        invoiceModalType,
    ]);

    const calculatedWithholdingAmount = useMemo(() => {
        const activePercent = resolveActiveWithholdingPercent();
        if (activePercent == null) {
            return 0;
        }
        return computeWithholdingAmount(activePercent);
    }, [
        totalReceiptAmountForWithholding,
        totalReceiptAmount,
        totalInvoiceAmount,
        invoiceModalType,
        autoClientWithholding,
        withholdingPercent,
        receiptClientDeductionRatePercent,
        formData.invoiceAccountCodeId,
        accountCardOptions,
    ]);

    const handleWithholdingPercentChange = (percentValue) => {
        setWithholdingPercent(percentValue);
        if (!percentValue || isNaN(Number(percentValue))) {
            return;
        }
        const w = computeWithholdingAmount(Number(percentValue));
        setFormData((prev) => ({
            ...prev,
            invoiceWithholdingTax: w.toString(),
        }));
    };

    const handleReceiptAutoWithholdingChange = (checked) => {
        setAutoClientWithholding(checked);
        if (!checked) {
            return;
        }
        const selectedCard = findAccountCardById(formData.invoiceAccountCodeId);
        const deductionRate = getDeductionRatePercentFromAccountCard(selectedCard);
        if (deductionRate == null) {
            return;
        }
        setWithholdingPercent(deductionRate.toString());
        const w = computeWithholdingAmount(deductionRate);
        setFormData((prev) => ({
            ...prev,
            invoiceWithholdingTax: w.toString(),
        }));
    };

    const handleAddWithholdingTaxClick = () => {
        setWithholdingTaxRowAdded(true);

        const selectedCard = findAccountCardById(formData.invoiceAccountCodeId);
        const deductionRate = getDeductionRatePercentFromAccountCard(selectedCard);
        if (deductionRate === null) {
            setAutoClientWithholding(false);
            setWithholdingPercent('');
            return;
        }

        setAutoClientWithholding(true);
        setWithholdingPercent(deductionRate.toString());

        const calculatedWithholdingTax = computeWithholdingAmount(deductionRate);

        setFormData((prev) => ({
            ...prev,
            invoiceWithholdingTax: calculatedWithholdingTax.toString(),
        }));
    };

    const handleRemoveWithholdingTaxRow = () => {
        setAutoClientWithholding(false);
        setWithholdingPercent('');
        setWithholdingTaxRowAdded(false);
        setFormData((prev) => ({
            ...prev,
            invoiceWithholdingTax: '',
        }));
    };

    /**
     * Take the current difference between the invoice total and the receipt
     * total (the value displayed on the totals panel) and apply it as a single
     * "Rounding Difference" line item with a fixed sentinel makat (ROUNDING_MAKAT).
     *
     * The user is expected to enter whole-shekel payment amounts; this button
     * just consumes whatever fractional gap is left over.
     *
     * Behavior:
     *  - If a rounding item already exists (matched by makat === ROUNDING_MAKAT),
     *    its price is updated by adding the new delta. If the resulting price is
     *    ~0 the row is removed entirely.
     *  - Otherwise a fresh rounding line is appended.
     *  - The item is created with isNew=false and itemId=null so it is never
     *    persisted to the ClientItems table by the backend / save logic.
     *
     * Only meaningful for invoice-receipts (modal type 5).
     */
    const handleRoundReceipt = () => {
        if (invoiceModalType !== 5) {
            return;
        }

        // Difference shown on the totals panel:
        //   shownDifference = totalInvoiceAmount - totalReceiptAmount
        // To make the invoice match the receipt we add an item whose price
        // is the negative of that, i.e. (totalReceiptAmount - totalInvoiceAmount).
        const delta = Number((totalReceiptAmount - totalInvoiceAmount).toFixed(2));

        if (Math.abs(delta) < 0.005) {
            toast.info(t('AmountsAlreadyRounded'));
            return;
        }

        // Guard: only allow tiny "rounding" adjustments (up to 1 shekel).
        // Anything larger is almost certainly a real entry mistake, not a
        // rounding artifact – do not silently sweep it into a synthetic line.
        if (Math.abs(delta) > 1) {
            toast.warning(t('RoundReceiptDifferenceTooLarge'));
            return;
        }

        const existingIdx = formData.invoiceItems.findIndex(
            (it) => String(it.makat) === ROUNDING_MAKAT
        );

        if (existingIdx !== -1) {
            const existing = formData.invoiceItems[existingIdx];
            const newPrice = Number(((Number(existing.price) || 0) + delta).toFixed(2));

            if (Math.abs(newPrice) < 0.005) {
                // The accumulated rounding cancels out – drop the line entirely.
                setFormData((prev) => ({
                    ...prev,
                    invoiceItems: prev.invoiceItems.filter((_, i) => i !== existingIdx),
                }));
                setAddItemFlags((prevFlags) => prevFlags.filter((_, i) => i !== existingIdx));
            } else {
                setFormData((prev) => {
                    const updated = [...prev.invoiceItems];
                    updated[existingIdx] = {
                        ...existing,
                        price: newPrice,
                        // Keep the row protected from accidental persistence.
                        isNew: false,
                        itemId: null,
                    };
                    return { ...prev, invoiceItems: updated };
                });
            }
        } else {
            const roundingItem = {
                makat: ROUNDING_MAKAT,
                name: t('RoundingDifference'),
                quantity: 1,
                price: delta,
                discount: 0,
                includeVat: false, // price is treated as the final delta, no VAT applied
                isNew: false,
                itemId: null,
            };

            setFormData((prev) => ({
                ...prev,
                invoiceItems: [...prev.invoiceItems, roundingItem],
            }));
            setAddItemFlags((prevFlags) => [...prevFlags, false]);
        }

        // Adding/updating the rounding item changes totalInvoiceAmount, which
        // would trigger the auto-recompute effect and reintroduce a fractional
        // withholding amount, breaking the match.
        // Lock the current withholding value by clearing the percent / auto flag.
        if (withholdingTaxRowAdded) {
            setAutoClientWithholding(false);
            setWithholdingPercent('');
        }
    };

    useEffect(() => {
        if (!withholdingTaxRowAdded) return;

        const activePercent = resolveActiveWithholdingPercent();
        if (activePercent == null) {
            if (autoClientWithholding) {
                setAutoClientWithholding(false);
            }
            return;
        }

        const nextWh = computeWithholdingAmount(activePercent);
        setFormData((prev) => {
            const cur = parseFloat(prev.invoiceWithholdingTax) || 0;
            if (Math.abs(cur - nextWh) < 0.005) {
                return prev;
            }
            return {
                ...prev,
                invoiceWithholdingTax: nextWh.toString(),
            };
        });
    }, [
        withholdingTaxRowAdded,
        autoClientWithholding,
        withholdingPercent,
        formData.invoiceAccountCodeId,
        accountCardOptions,
        totalReceiptAmountForWithholding,
        totalReceiptAmount,
        totalInvoiceAmount,
        invoiceModalType,
        formData.invoiceItems,
        formData.priceIncludingVAT,
        formData.forceNoTax,
    ]);

    const handleAccountCodeChange = (selectedOption) => {

        if (selectedOption?.value1 === 'AddItem') {
            // Clear formData fields when adding a new item
            setFormData((prev) => ({
                ...prev,
                invoiceAccountCodeId: cardIdOption,
                invoiceClientCaseId: '',
                invoiceClientName: '',
                invoiceClientEmail: '',
                invoiceClientPhoneNumber: '',
                invoiceClientLocation: '',
            }));
            setAddNewAccountCardDocument(true);
        } else {
            // Set formData fields based on selected option
            const accountCard = findAccountCardById(selectedOption?.value);
            const cardBankDetails = getCardBankDetails(accountCard);
            const fillEmptyBankRows = (items = []) =>
                cardBankDetails
                    ? items.map((item) => (rowHasBankDetails(item) ? item : { ...item, ...cardBankDetails }))
                    : items;

            setFormData((prev) => ({
                ...prev,
                invoiceAccountCodeId: selectedOption?.value || '',
                invoiceClientCaseId: selectedOption?.accountCaseId || '',
                invoiceClientName: selectedOption?.name || accountCard?.name || '',
                invoiceClientEmail: accountCard ? accountCard.email : '',
                invoiceClientLocation: accountCard ? accountCard.location : '',
                invoiceClientPhoneNumber: accountCard ? accountCard.phoneNumber : '',
                receiptItems: {
                    ...prev.receiptItems,
                    checks: fillEmptyBankRows(prev.receiptItems?.checks),
                    bankTransactions: fillEmptyBankRows(prev.receiptItems?.bankTransactions),
                },
            }));
        }
    };

    const formattedAccountCardOptions = accountCardOptions
        .filter((option) =>
            shouldIncludeClientAccountCard(option, {
                showAll: showAllAccountCards,
                selectedCardId: formData.invoiceAccountCodeId,
            })
        )
        .map(option => ({
            value: option.value1 === 'AddItem' ? 'AddItem' : parseInt(option.cardId, 10), // Ensure it's a number
            label: option.accountCaseId
                ? `${option.name} - ${option.accountCaseId}`
                : `${option.name}`,
            name: option.name,
            accountCaseId: option.accountCaseId || '',
            cardId: option.value1 === 'AddItem' ? 'AddItem' : parseInt(option.cardId, 10),
            value1: option.value1,
            email: option.email || '',
            kind: option.value1 === 'AddItem' ? 'add' : undefined,
        }));

    useEffect(() => {
        if (accountCardOptions && accountCardOptions.length > 0) {
            const maxCardId = Math.max(...accountCardOptions.slice(1).map((option) => parseInt(option.cardId, 10)));
            setCardIdOption(maxCardId + 1);
        }
    }, [accountCardOptions]);

    const handleCloseAddItem = (index) => {
        const updatedFlags = [...addItemFlags];
        updatedFlags[index] = false;
        setAddItemFlags(updatedFlags);
    };

    const handleAddMakatAndCheck = (index, value) => {
        // Check if the makat already exists in clientItems
        const existingItem = clientItems.find(item => item.makat === value);

        if (existingItem) {
            // Makat exists, alert the user or handle accordingly
            toast.error(t('MakatAlreadyExists'));
        } else {
            // Update the makat value
            handleItemChange(index, 'makat', value);
        }
    };

    // When user types/blurs makat: if it exists in clientItems, auto-fill item details (easier than select)
    const handleMakatBlurOrEnter = async (index, makatValue) => {
        const trimmed = String(makatValue || '').trim();
        if (!trimmed) return;

        const existingItem = clientItems.find(
            (item) => String(item.makat) === trimmed || item.makat === trimmed
        );
        if (!existingItem) return;

        const newValue = { value: existingItem.makat, label: existingItem.name };
        await handleInvoiceItem(index, newValue);
    };

    const validateInvoiceData = () => {
        let valid = true;

        if (formData.invoiceClientEmail && !validateEmail(formData.invoiceClientEmail)) {
            toast.error(t('InvalidEmailAddress'));
            valid = false;
        }

        if (formData.invoiceClientPhoneNumber && !validateNumber(formData.invoiceClientPhoneNumber)) {
            toast.error(t('InvalidPhoneNumber'));
            valid = false;
        }

        if (formData.invoiceClientCaseId && !validateNumber(formData.invoiceClientCaseId)) {
            toast.error(t('InvalidCaseId'));
            valid = false;
        }

        if (invoiceModalType !== 6) {
            formData.invoiceItems.forEach((item) => {
                item.quantity = item.quantity?.toString().replace(/\s+/g, '') ?? '';
                item.price = item.price?.toString().replace(/\s+/g, '') ?? '';
                item.discount = item.discount?.toString().replace(/\s+/g, '') ?? '';

                if (item.quantity <= 0) {
                    toast.error(t('invalidQuantity'));
                    valid = false;
                    return;
                }

                if (isNaN(item.price) || !validateAmount(item.price.toString())) {
                    valid = false;
                    toast.error(t('invalidPrice'));
                    return;
                }

                if (isNaN(item.discount) || item.discount < 0 || item.discount > 100) {
                    valid = false;
                    toast.error(t('invalidDiscount'));
                    return;
                }
            });
        }

        if (invoiceModalType === 5 || invoiceModalType === 6) {
            const { checks, creditCards, cash, bankTransactions } = formData.receiptItems;

            const validateReceiptItems = (items, type) => {
                items.forEach((item, index) => {
                    if (!validateAmount(item.amount)) {
                        toast.error(t('InvalidAmountAtPosition', { type: type, index: index + 1 }));
                        valid = false;
                    }
                });
            };

            validateReceiptItems(checks, t('Checks'));
            validateReceiptItems(creditCards, t('Credit Cards'));
            validateReceiptItems(cash, t('Cash'));
            validateReceiptItems(bankTransactions, t('Bank Transactions'));
        }

        return valid;
    };



    const validateNumber = (number) => {
        const re = /^[0-9\b]+$/;
        return re.test(number);
    };

    const validateAmount = (amount) => {
        const re = /^-?\d+(\.\d+)?$/;
        return re.test(amount);
    };
    const [updateInventory, setUpdateInventory] = useState(false);
    const [segmentationProjects, setSegmentationProjects] = useState([]);
    const [selectedSegmentation, setSelectedSegmentation] = useState(null);

    /**
     * Compares the invoice line quantities (for items linked to inventory) against
     * the current stock. If any item would be reduced to zero or below, shows a
     * confirmation dialog. Returns true if the user wants to continue.
     */
    const confirmInventoryStockWarnings = async () => {
        const items = formData.invoiceItems || [];
        const warnings = [];
        items.forEach((item) => {
            const itemId = item.itemId;
            if (!itemId || item.isNew) return;
            if (!(itemId in inventoryStockByItemId)) return;
            const available = inventoryStockByItemId[itemId];
            const requested = Number(item.quantity) || 0;
            if (requested >= available) {
                warnings.push({ name: item.name || item.makat || itemId, available, requested });
            }
        });

        if (warnings.length === 0) return true;

        const lines = warnings
            .map((w) => `• ${w.name}: ${t('Available') || 'Available'} ${w.available}, ${t('Requested') || 'Requested'} ${w.requested}`)
            .join('<br/>');
        const res = await Swal.fire({
            title: t('StockDepletionWarningTitle') || 'Stock will reach zero',
            html: `${t('StockDepletionWarningBody') || 'The following items will reach 0 (stock will not go negative):'}<br/><br/>${lines}<br/><br/>${t('ContinueQuestion') || 'Do you want to continue?'}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('Yes') || 'Yes',
            cancelButtonText: t('No') || 'No',
            reverseButtons: true,
        });
        return res.isConfirmed;
    };

    const getDocumentTypeForPendingReceipt = () => {
        // 0 invoice receipt types often use ReceiptTax; plain 0/1 tax invoice maps vary by modal.
        if (invoiceModalType === 0 || invoiceModalType === 1 || invoiceModalType === 5) return 'ReceiptTax';
        if (invoiceModalType === 4) return 'CreditNote';
        return 'TaxInvoice';
    };

    const ensureNoPendingDecisionReceipt = async () => {
        if (![0, 1, 4, 5].includes(invoiceModalType)) return true;
        try {
            const status = await TaxAuthorityService.getPendingInvoiceDecisionStatus(
                client.caseId,
                token,
                getDocumentTypeForPendingReceipt()
            );
            // AwaitingDocument needs no decision but still blocks the reference: its document must
            // be issued on that same number before any new invoice can be created.
            const awaitingDocument =
                (status?.status || status?.Status) === 'AwaitingDocument';

            if (status?.requiresDecision || status?.RequiresDecision || awaitingDocument) {
                setPendingDecisionStatus(status);
                setResolvePendingMode(true);
                setIsTaxAuthorityErrorModalVisible(true);
                return false;
            }
            return true;
        } catch (e) {
            console.warn('Pending decision check failed; continuing', e);
            return true;
        }
    };

    const handleCreateDraftInvoice = async () => {
        if (client?.isActive === false) {
            toast.error(t('ClientInactiveCannotCreateDocuments'));
            return;
        }
        if ((invoiceModalType === 5 || invoiceModalType === 6) && client?.leadingBusiness && allClientsOfAccountant.includes(formData.invoiceClientCaseId)) {
            const result = await Swal.fire({
                title: t('UpdateLedgerQuestion'),
                text: t('UpdateCollectionSystem'),
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: t('Yes'),
                cancelButtonText: t('No'),
                reverseButtons: true,
            });

            if (result.isConfirmed) {
                setUpdateLedger(true);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                setUpdateLedger(false);

            } else {
                // user closed the dialog – abort draft creation
                return;
            }
        }



        if (isInventoryDocument && client?.managesInventory) {
            const result1 = await Swal.fire({
                title: t('UpdateInventoryQuestion') || 'Do you want to update the inventory?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: t('Yes') || 'Yes',
                cancelButtonText: t('No') || 'No',
                reverseButtons: true,
            });

            if (result1.isConfirmed) {
                // Warn if any item would deplete stock to zero or below
                const proceed = await confirmInventoryStockWarnings();
                if (!proceed) {
                    return;
                }
                // ✅ Add flag to formData to be used in handleCreateInvoice
                setUpdateInventory(true); // true means update inventory
            } else {
                setUpdateInventory(false); // false means don't update inventory
            }
        }

        const canProceedDraft = await ensureNoPendingDecisionReceipt();
        if (!canProceedDraft) {
            return;
        }

        setLoading(true);

        // Validate the invoice data
        let valid = validateInvoiceData();

        if (!valid) {
            setLoading(false);
            return;
        }

        // Compute total payment amount
        const sumPaymentAmounts = (arr) =>
            Array.isArray(arr) ? arr.reduce((sum, item) => sum + parseFloat(item.amount) || 0, 0) : 0;

        const { checks, creditCards, cash, bankTransactions, offsets } = formData.receiptItems;
        let totalPaymentAmount = 0;
        if (invoiceModalType === 5 || invoiceModalType === 6) {
            totalPaymentAmount =
                sumPaymentAmounts(checks) +
                sumPaymentAmounts(creditCards) +
                sumPaymentAmounts(cash) +
                sumPaymentAmounts(bankTransactions) +
                sumPaymentAmounts(offsets) +
                (parseFloat(formData.invoiceWithholdingTax) || 0); // Include invoiceWithholdingTax here
        }

        // Compute total invoice amount
        const VAT_RATE = getVatValue(formData.invoiceDate);

        const totalInvoiceAmount = computeTotalInvoiceAmount();

        
        
        if (
            invoiceModalType === 5 &&
            (checks?.length > 0 || creditCards?.length > 0 || cash?.length > 0 || bankTransactions?.length > 0 || offsets?.length > 0) &&
            Math.abs(totalPaymentAmount - totalInvoiceAmount) > 0.01 // allow for floating point rounding
        ) {
            
            toast.error(t('AmountMismatch'));
            setLoading(false);
            return;
        }

        // Build Receipt object if necessary
        let Receipt = {};
        if (invoiceModalType === 5 || invoiceModalType === 6) {
            const withholdingTaxValue = parseFloat(formData.invoiceWithholdingTax) || 0;
            Receipt = {
                WithholdingTax: withholdingTaxValue, // Include invoiceWithholdingTax
                checks: withLocalCalendarPaymentDates(formData.receiptItems.checks),
                creditCards: withLocalCalendarPaymentDates(formData.receiptItems.creditCards),
                cash: withLocalCalendarPaymentDates(formData.receiptItems.cash),
                bankTransactions: withLocalCalendarPaymentDates(formData.receiptItems.bankTransactions),
                offsets: withLocalCalendarPaymentDates(formData.receiptItems.offsets),
                Title: InvoiceModalTypes[invoiceModalType].TransactionDocumentTitle,
                IsInvoiceReceipt: invoiceModalType === 5,
                ...(invoiceModalType === 6 && (relatedIncomeId || relatedInvoiceReference)
                    ? {
                        RelatedIncomeId: relatedIncomeId || null,
                        RelatedInvoiceReference: relatedInvoiceReference || null,
                    }
                    : {}),
            };
        }

        // Determine VAT logic based on requirements
        let useComplexVatLogic = needsComplexVatLogic();
        let forceNoTax = formData.forceNoTax;
        let priceIncludingVAT = formData.priceIncludingVAT;
        
        // Case 1: When PriceIncludingVAT = true and all items have NoVATCalculation, set useComplexVatLogic = false
        if (allItemsHaveNoVATCalculation()) {
            useComplexVatLogic = false;
        }
        
        // Case 2: When InvoiceWithNoTax is selected, set useComplexVatLogic = false and priceIncludingVAT = false
        if (formData.forceNoTax) {
            useComplexVatLogic = false;
        }
        
        // Case 3: When PriceIncludingVAT = true and all items have NoVATCalculation, enable ForceNoTax = true
        if (allItemsHaveNoVATCalculation()) {
            forceNoTax = true;
        }
        
        // Build invoice object
        const invoice = {
            CaseId: client.caseId,
            AccountantId: client.accountantId,
            Name: client.name,
            Description: linkedDocumentDescription() || formData.invoiceDescription,
            Reference: invoiceReference,
            ClientName: formData.invoiceClientName,
            ClientCaseId: formData.invoiceClientCaseId,
            PhoneNumber: client.phoneNumber,
            SecondaryPhoneNumber: client.secondaryPhoneNumber,
            Email: client.email,
            Website: client.website,
            Location: client.location,
            ClientLocation: formData.invoiceClientLocation,
            ClientEmail: formData.invoiceClientEmail,
            ClientPhoneNumber: formData.invoiceClientPhoneNumber,
            Date: formData.invoiceDate,
            Signature: invoiceSignature,
            AccountCodeId: formData.invoiceAccountCodeId.toString(),
            Items: invoiceModalType !== 6 ? formData.invoiceItems : undefined, // Exclude Items if invoiceModalType is 6
            PriceIncludingVAT: priceIncludingVAT,
            ...(invoiceModalType === 5 || invoiceModalType === 6 ? Receipt : {}),
            ForceNoTax: forceNoTax,
            DeferredReceipt: deferredReceipt,
            ForeignCurrencyCode: formData.foreignCurrencyCode,
            //             Decision: decisionFlag, // Add the decision flag,
            useComplexVatLogic: useComplexVatLogic,
            Language: formData.language,
            SendToCreator: !!formData.sendToCreator,
            // IsInvoiceReceipt:true
        };

        try {
            // Call the API to generate draft invoice
            const response = await DocumentService.CreateDraftInvoice(
                InvoiceModalTypes[invoiceModalType].controller,
                InvoiceModalTypes[invoiceModalType].draftEndPoint,
                invoice,
                InvoiceModalTypes[invoiceModalType].type,
                InvoiceModalTypes[invoiceModalType].TransactionDocumentTitle,
                InvoiceModalTypes[invoiceModalType].TransactionDocumentType,
                token
            );

            // This is the expected PDF blob
            const pdfBlob = response;
            setDraftPdfBlob(pdfBlob);
            setDraftPdfModalVisible(true);

            toast.success(t('DraftDocumentCreated'));
        } catch (error) {
            console.error('Error creating draft invoice:', error);
            toast.error(t('DraftDocumentDidNotCreated'));
        } finally {
            setLoading(false);
        }
    };


    const updateLocationState = async (newClientData, screen, type) => {

        const updatedClientData = {
            ...location.state.client,
            ...newClientData
        };

        if (screen === '/Document') {
            viewDocumentDetails(type);
        } else if (screen === '/TransactionDocuments') {
            viewTransactionDocuments(type);
        } else if (screen === '/PaymentAcceptance') {
            viewPaymentAcceptanceDetails(type);
        }
    };
    const handleSaveSignature = async (screen, type) => {
        const Client = await ClientService.GetClient(token, client.caseId);
        updateLocationState(Client, screen, type);

    }

    const saveNewItemsToDatabase = async (invoiceItems) => {
        try {

            // Filter out new items that need to be saved
            const itemsToSave = invoiceItems.filter(item => item.isNew);

            // Map items to the format expected by the API
            const itemsData = itemsToSave.map(item => ({
                makat: item.makat,
                name: item.name,
                caseId: client.caseId,
                price: item.price
                // Include other necessary fields if needed
            }));

            // Call the API to save new items
            const response = await ClientItemsService.AddClientItems(itemsData, token);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            const createdItems = data.items || [];
            // Update clientItems state with the new items
            setClientItems(prevClientItems => [...prevClientItems, ...itemsToSave]);

            // Clear newItems array after saving
            setFormData(prevState => ({
                ...prevState,
                invoiceItems: prevState.invoiceItems.map(item => ({ ...item, isNew: false })),
            }));
            return createdItems;
            // Optionally, update the addItemFlags if needed
        } catch (error) {
            console.error('Error saving new items:', error);
            toast.error(t('ErrorSavingNewItems'));
        }
    };




    const handleTaxAuthorityOptionSelect = (decisionFlag, options) => {
        // if (options?.forceNoConfirmationNumber) {
        //     handleCreateInvoice(true, null, true);
        //     return;
        // }
        if (decisionFlag !== undefined && decisionFlag !== null) {
            handleCreateInvoice(true, decisionFlag);
        }
    };

    /**
     * Issue a held document from the invoice the Tax Authority decision was accepted for.
     *
     * The decision covers the invoice SHAAM is holding under that number, so its own lines are the
     * ones that have to be issued. The form usually shows a different document by now — the one the
     * user was typing when the held number blocked them — and posting that would put those lines on
     * the held number while the real invoice stays unissued.
     */
    const finishHeldInvoiceFromSnapshot = async (status, decisionFlag) => {
        setLoading(true);
        try {
            const generated = await TaxAuthorityService.generateDocumentWithDecision(
                status,
                decisionFlag,
                token
            );

            if (generated?.type === 'text') {
                toast.success(generated.message || t('TaxAuthorityRequestSent'));
                handleInvoiceClose();
                return;
            }

            let blob = generated?.type === 'pdf' ? generated.blob : null;
            if (generated?.type === 'json') {
                const { presignedUrl, pdfBytes } = generated.data || {};
                if (pdfBytes) {
                    const bytes = Uint8Array.from(atob(pdfBytes), (c) => c.charCodeAt(0));
                    blob = new Blob([bytes], { type: 'application/pdf' });
                } else if (presignedUrl) {
                    blob = await (await fetch(presignedUrl)).blob();
                }
            }

            if (blob) {
                setPdfBlob(blob);
                setPdfModalVisible(true);
            }

            toast.success(invoiceModalType === 6 ? t('ReceiptCreated') : t('InvoiceCreated'));
            handleInvoiceClose();
        } catch (error) {
            console.error(error);
            const message = error?.message || '';
            toast.error(
                message === 'MissingStoredInvoiceSnapshot'
                    ? t('MissingStoredInvoiceSnapshot')
                    : message || t('ErrorGeneratingInvoice'),
                { autoClose: false }
            );
        } finally {
            setLoading(false);
        }
    };

    const handlePendingDecisionResolved = ({ decisionFlag, action, invoiceId }) => {
        const status = {
            ...(pendingDecisionStatus || {}),
            invoiceId: invoiceId || pendingDecisionStatus?.invoiceId || pendingDecisionStatus?.InvoiceId,
            InvoiceId: invoiceId || pendingDecisionStatus?.invoiceId || pendingDecisionStatus?.InvoiceId,
        };
        setResolvePendingMode(false);
        setPendingDecisionStatus(null);

        // Cancel still issues a document: a zero-amount canceled placeholder with Decision=0.
        const isCancel = decisionFlag === 0 || action === 'Cancel';
        if (isCancel) {
            toast.info(t('InvoiceCancelledSuccessfully'));
        }

        const flag = isCancel ? 0 : decisionFlag;

        // The decision covers the document SHAAM is holding, so issue that snapshot — never the
        // form the user happens to be filling (often a different receipt that tripped the 4900).
        finishHeldInvoiceFromSnapshot(status, flag);
    };

    const handleCreateInvoice = async (isAuthCompleted = false, decisionFlag = null, forceNoConfirmationNumber = false, resumeReference = null) => {
        if (client?.isActive === false) {
            toast.error(t('ClientInactiveCannotCreateDocuments'));
            return;
        }
        if (!isAuthCompleted && decisionFlag === null) {
            const canProceed = await ensureNoPendingDecisionReceipt();
            if (!canProceed) {
                return;
            }
        }
        setLoading(true);
        // Validate the invoice data
        let valid = validateInvoiceData();

        if (!valid) {
            setLoading(false);
            return;
        }

        // "שיוך מסמכים": the amount linked to invoices / sources may not exceed the receipt amount.
        if ((invoiceModalType === 5 || invoiceModalType === 6) && receiptLinking.validation.overAllocated) {
            toast.error(t('LinkDocumentsOverAllocated'));
            setLoading(false);
            return;
        }

        // Ensure all invoiceItems have correct itemId before API call
        // Skip the synthetic rounding item: it has no real ClientItem to link to
        // and must never be persisted to the ClientItems table.
        let updatedInvoiceItems = [...formData.invoiceItems];
        const itemsNeedingId = updatedInvoiceItems.filter(item =>
            !item.isNew &&
            String(item.makat) !== ROUNDING_MAKAT &&
            (!item.itemId || item.itemId === 0)
        );
        if (itemsNeedingId.length > 0) {
            try {
                const clientItemsResponse = await ClientItemsService.GetClientItemsByCaseId(client.caseId, token);
                if (clientItemsResponse.ok) {
                    const clientItemsData = await clientItemsResponse.json();
                    updatedInvoiceItems = updatedInvoiceItems.map(item => {
                        if (
                            !item.isNew &&
                            String(item.makat) !== ROUNDING_MAKAT &&
                            (!item.itemId || item.itemId === 0)
                        ) {
                            const found = clientItemsData.find(ci => ci.makat === item.makat);
                            if (found && found.id) {
                                return { ...item, itemId: found.id };
                            }
                        }
                        return item;
                    });
                    setClientItems(clientItemsData); // Optionally update cache
                }
            } catch (err) {
                console.error('Failed to fetch latest client items for itemId update before API call', err);
            }
        }

        let newlyCreatedItems = [];
        if (updatedInvoiceItems.some(item => item.isNew)) {
            newlyCreatedItems = await saveNewItemsToDatabase(updatedInvoiceItems);
        }

        updatedInvoiceItems = updatedInvoiceItems.map((localItem) => {
            if (!localItem.isNew) {
                return localItem; // already had ID, so do nothing
            }
            // Find the matching newly created item by 'makat' or some unique field
            const matched = newlyCreatedItems.find(ci => ci.makat === localItem.makat);
            if (matched) {
                return {
                    ...localItem,
                    itemId: matched.id, // real DB ID
                    isNew: false,
                };
            }
            // If not found for some reason, just return the original
            return localItem;
        });

        // 4. Update your formData state so the items have real IDs
        setFormData(prev => ({
            ...prev,
            invoiceItems: updatedInvoiceItems
        }));
        // Check if the month is closed, if necessary
        if (invoiceModalType === 0 || invoiceModalType === 1 || invoiceModalType === 5) {
            try {
                const response = await UserService.CheckIfMonthClosed(client.caseId, formData.reportingMonthDate, token);
                if (response.ok) {
                    const isClosedReportingMonth = await response.json();
                    if (isClosedReportingMonth) {
                        toast.info(t('MonthReportAlreadyClosedTryAgain'));
                        setLoading(false);
                        return;
                    }
                }
            } catch (error) {
                console.error('Error checking if month is closed:', error);
                // Handle error if needed
            }
        }

        // Validate email, phone number, client case ID
        if (formData.invoiceClientEmail && !validateEmail(formData.invoiceClientEmail)) {
            toast.error(t('InvalidEmailAddress'));
            valid = false;
        }

        if (formData.invoiceClientPhoneNumber && !validateNumber(formData.invoiceClientPhoneNumber)) {
            toast.error(t('InvalidPhoneNumber'));
            valid = false;
        }

        if (formData.invoiceClientCaseId && !validateNumber(formData.invoiceClientCaseId)) {
            toast.error(t('InvalidCaseId'));
            valid = false;
        }

        // Validate invoice items
        formData.invoiceItems.forEach(item => {
            item.quantity = item.quantity?.toString().replace(/\s+/g, '') ?? '';
            item.price = item.price?.toString().replace(/\s+/g, '') ?? '';
            item.discount = item.discount?.toString().replace(/\s+/g, '') ?? '';

            if (item.quantity <= 0) {
                toast.error(t('invalidQuantity'));
                valid = false;
                return;
            }

            if (isNaN(item.price) || !validateAmount(item.price.toString())) {
                valid = false;
                toast.error(t('invalidPrice'));
                return;
            }

            if (isNaN(item.discount) || item.discount < 0 || item.discount > 100) {
                valid = false;
                toast.error(t('invalidDiscount'));
                return;
            }
        });

        // Validate amounts in receipt items
        const { checks, creditCards, cash, bankTransactions, offsets } = formData.receiptItems;

        if (checks && checks.length > 0) {
            for (const check of checks) {
                if (!validateAmount(check.amount)) {
                    toast.error(t('invalidCheckAmount'));
                    valid = false;
                    break;
                }
            }
        }

        if (creditCards && creditCards.length > 0) {
            for (const card of creditCards) {
                if (!validateAmount(card.amount)) {
                    toast.error(t('invalidCreditCardAmount'));
                    valid = false;
                    break;
                }
            }
        }

        if (cash && cash.length > 0) {
            for (const cashItem of cash) {
                if (!validateAmount(cashItem.amount)) {
                    toast.error(t('invalidCashAmount'));
                    valid = false;
                    break;
                }
            }
        }

        if (bankTransactions && bankTransactions.length > 0) {
            for (const transaction of bankTransactions) {
                if (!validateAmount(transaction.amount)) {
                    toast.error(t('invalidBankTransactionAmount'));
                    valid = false;
                    break;
                }
            }
        }

        if (offsets && offsets.length > 0) {
            for (const offset of offsets) {
                if (!validateAmount(offset.amount)) {
                    toast.error(t('invalidOffsetAmount'));
                    valid = false;
                    break;
                }
            }
        }

        if (!valid) {
            setLoading(false);
            return;
        }

        // Compute total payment amount
        const sumPaymentAmounts = (arr) =>
            Array.isArray(arr) ? arr.reduce((sum, item) => sum + parseFloat(item.amount) || 0, 0) : 0;

        let totalPaymentAmount = 0;
        if (invoiceModalType === 5 || invoiceModalType === 6) {
            totalPaymentAmount =
                sumPaymentAmounts(checks) +
                sumPaymentAmounts(creditCards) +
                sumPaymentAmounts(cash) +
                sumPaymentAmounts(bankTransactions) +
                sumPaymentAmounts(offsets) +
                (parseFloat(formData.invoiceWithholdingTax) || 0); // Include invoiceWithholdingTax here
        }

        // Compute total invoice amount

        const totalInvoiceAmount = computeTotalInvoiceAmount();

        
        
        if (
            invoiceModalType === 5 &&
            (checks?.length > 0 || creditCards?.length > 0 || cash?.length > 0 || bankTransactions?.length > 0 || offsets?.length > 0) &&
            Math.abs(totalPaymentAmount - totalInvoiceAmount) > 0.01 // allow for floating point rounding
        ) {
            
            toast.error(t('AmountMismatch'));
            setLoading(false);
            return;
        }


        const isTaxExemptOrNoTax =
            (client?.caseType && Constants.TaxExemptTypes.includes(client.caseType)) ||
            formData.forceNoTax;

        // Compute total invoice amount without VAT
        let totalInvoiceAmountWithoutVAT = 0;
        if (!isTaxExemptOrNoTax) {
            // Then we do the normal logic of "without VAT"
            totalInvoiceAmountWithoutVAT = formData.invoiceItems.reduce((sum, item) => {
                let price = parseFloat(item.price) || 0;
                price *= item.quantity || 1;
                const discountPercent = parseFloat(item.discount) || 0;
                const discountedPrice = price - (price * discountPercent) / 100;
                // If priceIncludingVAT was true, back it out
                return formData.priceIncludingVAT
                    ? sum + (discountedPrice / (1 + VAT_RATE))
                    : sum + discountedPrice;
            }, 0);
        }

        const skipConfirmationNumberRequest =
            formData.noNeedforConfirmationNumber || forceNoConfirmationNumber;

        // Check token for charity organizations (עמותה) unless user explicitly skips confirmation number
        const isCharityOrganization = client?.caseType === Constants.CharityOrganization;
        
        if (isCharityOrganization && !skipConfirmationNumberRequest && !isAuthCompleted) {
            try {
                taxAuthScopeRef.current = Constants.TaxAuthorityScopes.Donations;
                const tokenData = await TaxAuthorityService.requestTokenClient(client.caseId, token, Constants.TaxAuthorityScopes.Donations);

                if (tokenData?.authUrl) {
                    handleTaxAuthorityAuth(tokenData.authUrl);
                    setLoading(false);
                    return; // Wait for auth to complete
                }
            } catch (error) {
                console.error('Error fetching token for charity organization:', error);
                toast.error(t('TaxAuthorityAuthFetchError'));
                setLoading(false);
                return;
            }
        }

        const isNeedToAskAboutConfirmationNumber =
            (invoiceModalType === 0 || invoiceModalType === 1 || invoiceModalType === 4 || invoiceModalType === 5)
            && !formData.noNeedforConfirmationNumber;

        // If authentication is not completed and needed, request token
        if (
            !isTaxExemptOrNoTax && // <--- skip if we are exempt/noTax
            !isAuthCompleted &&
            isNeedToAskAboutConfirmationNumber &&
            totalInvoiceAmountWithoutVAT >= getIsraelInvoiceAmountLimit(formData.invoiceDate)
        ) {
            try {
                taxAuthScopeRef.current = Constants.TaxAuthorityScopes.CreationNumber;
                const tokenData = await TaxAuthorityService.requestTokenClient(client.caseId, token, Constants.TaxAuthorityScopes.CreationNumber);

                if (tokenData?.authUrl) {
                    handleTaxAuthorityAuth(tokenData.authUrl);
                    setLoading(false);
                    return; // Wait for auth to complete
                }

            } catch (error) {
                console.error('Error fetching token:', error);
                toast.error(t('TaxAuthorityAuthFetchError'));
                setLoading(false);
                return;
            }
        }



        // Build Receipt object if necessary
        let Receipt = {};
        if (invoiceModalType === 5 || invoiceModalType === 6) {
            const withholdingTaxValue = parseFloat(formData.invoiceWithholdingTax) || 0;
            Receipt = {
                WithholdingTax: withholdingTaxValue, // Include invoiceWithholdingTax here
                IsInvoiceReceipt: invoiceModalType === 5,
                Title: InvoiceModalTypes[invoiceModalType]?.TransactionDocumentTitle,
                DeferredReceipt: deferredReceipt,
                ...(invoiceModalType === 6 && (relatedIncomeId || relatedInvoiceReference)
                    ? {
                        RelatedIncomeId: relatedIncomeId || null,
                        RelatedInvoiceReference: relatedInvoiceReference || null,
                    }
                    : {}),
            };
        }



        // Determine VAT logic based on requirements
        let useComplexVatLogic = needsComplexVatLogic();
        let forceNoTax = formData.forceNoTax;
        let priceIncludingVAT = formData.priceIncludingVAT;
        
        // Case 1: When PriceIncludingVAT = true and all items have NoVATCalculation, set useComplexVatLogic = false
        if (allItemsHaveNoVATCalculation()) {
            useComplexVatLogic = false;
        }
        
        // Case 2: When InvoiceWithNoTax is selected, set useComplexVatLogic = false and priceIncludingVAT = false
        if (formData.forceNoTax) {
            useComplexVatLogic = false;
        }
        
        // Case 3: When PriceIncludingVAT = true and all items have NoVATCalculation, enable ForceNoTax = true
        if (allItemsHaveNoVATCalculation()) {
            forceNoTax = true;
        }
        
        // Build the formData object
        const formDataToSend = new FormData();

        // Append fields to formDataToSend
        const newDocument = {
            CaseId: client.caseId,
            AccountantId: client.accountantId,
            Name: client.name,
            Description: linkedDocumentDescription() || formData.invoiceDescription,
            // Resuming a decision sends the held reference so it is used as-is.
            Reference: resumeReference ?? (invoiceReference || ""),
            ClientName: formData.invoiceClientName,
            ClientCaseId: formData.invoiceClientCaseId || "",
            PhoneNumber: client.phoneNumber,
            SecondaryPhoneNumber: client.secondaryPhoneNumber,
            Email: client.email,
            Website: client.website,
            Location: client.location,
            ClientLocation: formData.invoiceClientLocation,
            ClientEmail: formData.invoiceClientEmail,
            ClientPhoneNumber: formData.invoiceClientPhoneNumber,
            Date: new Date(formData.invoiceDate).toISOString(),
            reportingMonthDate: new Date(formData.reportingMonthDate).toISOString(),
            Signature: invoiceSignature || "",
            AccountCodeId: formData.invoiceAccountCodeId.toString(),
            PriceIncludingVAT: priceIncludingVAT,
            ForceNoTax: forceNoTax,
            DeferredReceipt: deferredReceipt,
            UpdateLedger: updateLedger,
            addToInventory: updateInventory,
            ForeignCurrencyCode: formData.foreignCurrencyCode,
            noNeedforConfirmationNumber:  formData.noNeedforConfirmationNumber,
            Decision: decisionFlag, // Option 4 (Request for Use): create without confirmation number
            useComplexVatLogic: useComplexVatLogic,
            Language: formData.language,
            SendToCreator: !!formData.sendToCreator,
            ...Receipt,
        };



        // Append each field to formData
        for (const key in newDocument) {
            if (newDocument[key] !== undefined && newDocument[key] !== null) {

                formDataToSend.append(key, newDocument[key]);
            }
        }




        // Append segmentation if selected
        if (selectedSegmentation?.id) {
            formDataToSend.append('SegmentationId', selectedSegmentation.id);
        }

        // Append Items if necessary

        if (invoiceModalType !== 6 && updatedInvoiceItems && updatedInvoiceItems.length > 0) {
            const items = updatedInvoiceItems.map(item => ({
                makat: item.makat || "",
                name: item.name || "",
                quantity: item.quantity || 0,
                price: item.price || 0,
                discount: item.discount || 0,
                includeVat: item.includeVat !== undefined ? item.includeVat : true, // Include VAT setting
                ...(item.itemId ? { itemId: item.itemId } : {}), // Only include itemId if it's truthy (not 0, null, or undefined)
            }));


            formDataToSend.append('Items', JSON.stringify(items));
        }



        // Append receipt items if necessary
        const appendArrayField = (fieldName, dataArray) => {
            if (dataArray && dataArray.length > 0) {
                const formattedData = dataArray.map(item => ({
                    ...item,
                    paymentDate: toLocalCalendarUtcIso(item.paymentDate),
                    amount: parseFloat(item.amount) || 0,
                }));
                formDataToSend.append(fieldName, JSON.stringify(formattedData));
            }
        };



        if (invoiceModalType === 5 || invoiceModalType === 6) {
            appendArrayField('Checks', formData.receiptItems.checks);
            appendArrayField('CreditCards', formData.receiptItems.creditCards);
            appendArrayField('Cash', formData.receiptItems.cash);
            appendArrayField('BankTransactions', formData.receiptItems.bankTransactions);
            appendArrayField('Offsets', formData.receiptItems.offsets);
            
            // Build FilePaymentMethodMapping for files attached to payment methods
            const fileMapping = [];
            let fileIndex = 0;
            
            // Append individual files from payment method items with naming convention
            formData.receiptItems.checks?.forEach((check, index) => {
                if (check.documentFile) {
                    formDataToSend.append(`check_${index}`, check.documentFile, check.documentFile.name);
                    fileMapping.push({ fileIndex: fileIndex++, paymentMethodType: 'checks' });
                }
            });
            
            formData.receiptItems.creditCards?.forEach((card, index) => {
                if (card.documentFile) {
                    formDataToSend.append(`creditcard_${index}`, card.documentFile, card.documentFile.name);
                    fileMapping.push({ fileIndex: fileIndex++, paymentMethodType: 'creditcards' });
                }
            });
            
            formData.receiptItems.cash?.forEach((cash, index) => {
                if (cash.documentFile) {
                    formDataToSend.append(`cash_${index}`, cash.documentFile, cash.documentFile.name);
                    fileMapping.push({ fileIndex: fileIndex++, paymentMethodType: 'cash' });
                }
            });
            
            formData.receiptItems.bankTransactions?.forEach((bank, index) => {
                if (bank.documentFile) {
                    formDataToSend.append(`bank_${index}`, bank.documentFile, bank.documentFile.name);
                    fileMapping.push({ fileIndex: fileIndex++, paymentMethodType: 'banktransactions' });
                }
            });

            formData.receiptItems.offsets?.forEach((offset, index) => {
                if (offset.documentFile) {
                    formDataToSend.append(`offset_${index}`, offset.documentFile, offset.documentFile.name);
                    fileMapping.push({ fileIndex: fileIndex++, paymentMethodType: 'offsets' });
                }
            });
            
            // Add FilePaymentMethodMapping to formData
            if (fileMapping.length > 0) {
                formDataToSend.append('FilePaymentMethodMapping', JSON.stringify(fileMapping));
            }
        }

        // "שיוך מסמכים": the documents the user chose to link while creating this receipt are
        // persisted atomically by the generate endpoint (as PaymentFor / GeneratedFrom relationships).
        if (invoiceModalType === 5 || invoiceModalType === 6) {
            const { sourceDocumentIds, sourceAllocations, relatedIncomeId: pendingRelatedIncomeId } =
                receiptLinking.payload;
            if (sourceDocumentIds.length > 0) {
                formDataToSend.append('SourceDocumentIds', JSON.stringify(sourceDocumentIds));
            }
            if (sourceAllocations.length > 0) {
                formDataToSend.append('SourceAllocations', JSON.stringify(sourceAllocations));
            }
            // Keep a RelatedIncomeId already set from the form; otherwise use the first linked invoice.
            if (pendingRelatedIncomeId && !formDataToSend.has('RelatedIncomeId')) {
                formDataToSend.append('RelatedIncomeId', pendingRelatedIncomeId);
            }
        }

        try {




            if (formData.documents && formData.documents.length > 0) {
                formData.documents.forEach((document) => {
                    formDataToSend.append('documents', document, document.name);
                });
            }




            setDraftPdfModalVisible(false);


            // Adjust the API call to use the function that accepts FormData
            const response = await DocumentService.CreateInvoiceWithDocuments(
                InvoiceModalTypes[invoiceModalType].controller,
                InvoiceModalTypes[invoiceModalType].endPoint,
                formDataToSend,
                client.caseId,
                token
            );

            // Check if the response is a success message (string) or PDF blob
            if (typeof response === 'string') {
                // This is a success message from the backend (e.g., "Decision processed successfully")
                if (response === 'Decision processed successfully') {
                    await Swal.fire({
                        title: t('Success') || 'Success!',
                        text: t('TaxAuthorityRequestSent'),
                        icon: 'success',
                        timer: 2000,
                        confirmButtonText: t('OK') || 'OK!'
                    });
                } else {
                    toast.success(response);
                }
                setLoading(false);
                handleInvoiceClose();
                return;
            }

            // Check if response is a text blob (success message) or PDF blob
            if (response instanceof Blob && response.type === 'text/plain') {
                const textResponse = await response.text();
                if (textResponse === 'Decision processed successfully') {
                    await Swal.fire({
                        title: t('Success') || 'Success!',
                        text: t('TaxAuthorityRequestSent'),
                        icon: 'success',
                        timer: 2000,
                        confirmButtonText: t('OK') || 'OK!'
                    });
                } else {
                    toast.success(textResponse);
                }
                setLoading(false);
                handleInvoiceClose();
                return;
            }

            // This is the expected PDF blob
            const pdfBlob = response;




            if (addNewAccountCardDocument) {
                await EnumsService.AddAccountCard(
                    client.caseId,
                    formData.invoiceAccountCodeId.toString(),
                    formData.invoiceClientName,
                    formData.invoiceClientCaseId,
                    'לקוחות',
                    token,
                    formData.invoiceClientPhoneNumber,
                    formData.invoiceClientLocation,
                    formData.invoiceClientEmail
                );
            }
            else {
                await EnumsService.UpdateAccountCardCaseId(client.caseId, formData.invoiceAccountCodeId.toString(), formData.invoiceClientCaseId, formData.invoiceClientEmail, formData.invoiceClientPhoneNumber, formData.invoiceClientLocation, token);
            }
            setPdfBlob(pdfBlob);
            setPdfModalVisible(true);
            if (invoiceModalType === 6) {
                toast.success(t('ReceiptCreated'));
            } else {
                toast.success(t('InvoiceCreated'));
            }
            handleInvoiceClose();
        } catch (error) {
            //toChange
            console.error(error);
            const errorMessage = error.message || "";
            
            // Check for error code (Tax Authority error - invoice or donation)
            // Always show the toast first
            
            let errorCodeMatch = errorMessage.match(/Error Code (\d+):/); // Extracts the number after "Error Code"
            if (!errorCodeMatch) {
                errorCodeMatch = errorMessage.match(/Status Code: (\d+),/); // Extracts the number after "Status Code:"
            }
            
            if (errorCodeMatch) {
                const errorCode = errorCodeMatch[1]; // Capture the error code
                
                const isDonationError = client?.caseType === 'עמותה';
                const isSubscriptionError = parseInt(errorCode) === 401;
                
                const translationKey = isDonationError || isSubscriptionError 
                    ? `TaxDonationError${errorCode}` 
                    : `TaxInvoiceError${errorCode}`;
                
                toast.error(t(translationKey) || errorMessage, { autoClose: false }); // Use the dynamic translation key and keep the toast open
                
                // Check if we should show the tax authority error modal for specific error codes
                if (errorCode === Constants.TaxAuthorityErrorCodes.INVOICE_NOT_APPROVED.toString() || 
                errorCode === Constants.TaxAuthorityErrorCodes.NO_DECISION_SENT.toString() ||
                errorCode === Constants.TaxAuthorityErrorCodes.REFERENCE_AWAITING_DOCUMENT.toString()) {
                    try {
                        const status = await TaxAuthorityService.getPendingInvoiceDecisionStatus(
                            client.caseId,
                            token,
                            getDocumentTypeForPendingReceipt()
                        );
                        setPendingDecisionStatus(status);
                        setResolvePendingMode(
                            !!(status?.requiresDecision || status?.RequiresDecision) ||
                            (status?.status || status?.Status) === 'AwaitingDocument'
                        );
                    } catch (e) {
                        setResolvePendingMode(false);
                        setPendingDecisionStatus(null);
                    }
                    setIsTaxAuthorityErrorModalVisible(true);
                }
            } else {
                toast.error(errorMessage); // Fallback message if no error code found
            }
        } finally {
            setLoading(false);
        }
    };


    const handleInvoiceClose = async () => {
        // Refetch client data to get updated information
        try {
            const updatedClient = await ClientService.GetClient(token, client.caseId);
            setClient(updatedClient);
        } catch (error) {
            console.error('Error refetching client data:', error);
        }

        setFormData({
            invoiceClientName: '',
            invoiceClientCaseId: '',
            invoiceAccountCodeId: null,
            invoiceClientEmail: '',
            invoiceClientPhoneNumber: '',
            invoiceClientLocation: '',
            invoiceDescription: '',
            sendToCreator: false,
            accountCodeId: "",
            priceIncludingVAT: true,
            invoiceDate: new Date(),
            reportingMonthDate: new Date(),
            invoiceItems: [],
            receiptItems: {
                checks: [],
                creditCards: [],
                cash: [],
                bankTransactions: [],
                offsets: [],
            },
            documents: [],
            invoiceWithholdingTax: '',
            forceNoTax: false,
            noNeedforConfirmationNumber: false,
            language: i18n.language || 'he',
        });
        setAddItemFlags([]);
        setInvoiceSignature('');
        setInvoiceReference('');
        setAddNewAccountCardDocument(false);
        setWithholdingTaxRowAdded(false);
        setAutoClientWithholding(false);
        setSelectedSegmentation(null);
        // setNeedReference(false);
        // setNeedSignature(false);
    };
    const handleReset = () => {
        // ... existing reset logic
        setNeedSignature(false);
        setNeedReference(false);
    };

    // Helper function to get reference key and default value for specific modal type
    const getReferenceKeyAndDefault = (modalType) => {
        switch (modalType) {
            case 0: // taxInvoice
                return { key: 'taxInvoiceReference', default: 0 };
            case 1: // creditNote
                return { key: 'creditNoteReference', default: 2000 };
            case 2: // quotation
                return { key: 'quotationReference', default: 0 };
            case 3: // order
                return { key: 'orderReference', default: 0 };
            case 4: // transaction
                return { key: 'transactionReference', default: 0 };
            case 5: // invoiceReceipt
                return { key: 'recieptTaxReference', default: 1000 };
            case 6: // receipt
                return { key: 'receiptReference', default: 0 };
            default:
                return null;
        }
    };

    // Helper function to check if reference for specific modal type is at default
    const checkIfReferenceIsDefault = (references, modalType) => {
        const refInfo = getReferenceKeyAndDefault(modalType);
        if (!refInfo) return false;
        
        return references[refInfo.key] === refInfo.default;
    };

    useEffect(() => {
        const checkReferencesAndSignature = async () => {
            if (!client || !token) return;

            let hasSignature = client.signature;
            let hasDocNumber = false;
            let referencesAreDefault = false;

            // Fetch references and check if they're at default values for this specific modal type
            try {
                const referencesResponse = await DocumentService.GetReferenceByCaseId(client.caseId, token);
                if (referencesResponse.success && referencesResponse.data) {
                    referencesAreDefault = checkIfReferenceIsDefault(referencesResponse.data, invoiceModalType);
                }
            } catch (error) {
                console.error('Error fetching references:', error);
                referencesAreDefault = true; // Assume default if fetch fails
            }

            switch (invoiceModalType) {
                case 0: // taxInvoice
                case 5: // invoiceReceipt
                    hasDocNumber = client.invoicesNumbers && client.invoicesNumbers !== 0;
                    break;
                case 1: // creditNote
                    hasDocNumber = client.invoicesNumbers && client.invoicesNumbers !== 0 && client.refundInvoicesNumbers && client.refundInvoicesNumbers !== 0;
                    break;
                case 2: // quotation
                    hasDocNumber = client.quotationInvoicesNumbers && client.quotationInvoicesNumbers !== 0;
                    break;
                case 3: // order
                    hasDocNumber = client.orderInvoicesNumbers && client.orderInvoicesNumbers !== 0;
                    break;
                case 4: // transactionInvoice
                    hasDocNumber = client.transactionInvoicesNumbers && client.transactionInvoicesNumbers !== 0;
                    break;
                case 6: // receipt
                    if (deferredReceipt) {
                        hasDocNumber = client.deferredReceiptNumbers && client.deferredReceiptNumbers !== 0;
                    } else {
                        hasDocNumber = client.receiptNumbers && client.receiptNumbers !== 0;
                    }
                    break;
                default:
                    hasDocNumber = false;
                    break;
            }

            // If references are at default values, need to collect reference
            if (referencesAreDefault) {
                if (hasSignature) {
                    // Has signature but references are default, need to collect reference only
                    setNeedSignature(false);
                    setNeedReference(true);
                    setSignatureReferenceInvoiceModalVisible(true);
                } else {
                    // No signature and references are default, need to collect both signature and reference
                    setNeedSignature(true);
                    setNeedReference(true);
                    setSignatureReferenceInvoiceModalVisible(true);
                }
                return;
            }

            // References are NOT at default (they've been set/customized)
            // Only check for signature, never ask for reference again
            if (hasSignature) {
                // Has signature and references are set, no need for modal
                setNeedSignature(false);
                setNeedReference(false);
                setSignatureReferenceInvoiceModalVisible(false);
            } else {
                // No signature but references are set, need to collect signature only
                setNeedSignature(true);
                setNeedReference(false);
                setSignatureReferenceInvoiceModalVisible(true);
            }
        };

        checkReferencesAndSignature();
    }, [client, invoiceModalType, deferredReceipt, token]);

    const handleVatRadioChange = (e) => {
        setEditedItem({ ...editedItem, ["vat"]: parseFloat(e.target.value) });
    };

    const fieldErrors = {
        /* single-value fields */
        invoiceAccountCodeId: !formData.invoiceAccountCodeId,
        invoiceClientName: !formData.invoiceClientName,
        invoiceClientPhoneNumber:
            !!formData.invoiceClientPhoneNumber && !validatePhoneNumber(formData.invoiceClientPhoneNumber),

        invoiceClientEmail: formData.invoiceClientEmail &&
            !validateEmail(formData.invoiceClientEmail),
        reportingMonthDate: !formData.reportingMonthDate,
        invoiceDate: !formData.invoiceDate,
        invoiceClientCaseId: isAmountAboveLimit && !isValidShaamCustomerVatNumber(formData.invoiceClientCaseId) && !formData.noNeedforConfirmationNumber,

        /* invoice items errors (empty if modalType === 6) */
        invoiceItems: formData.invoiceItems.map(it => ({
            name: !it.name,
            makat: !it.makat,
            price: !it.price,
            quantity: !it.quantity || it.quantity <= 0,
            discount: (
                it.discount === null ||
                it.discount === undefined ||
                it.discount === '' ||
                isNaN(it.discount) ||
                it.discount < 0 ||
                it.discount > 100
            )
        })),

        /* receipt rows (for modalType 5/6) */
        receiptItems: {
            checks: (formData.receiptItems?.checks ?? []).map(r => ({
                amount: !r.amount,
                date: !r.paymentDate,
                description: !r.description,
            })),
            creditCards: (formData.receiptItems?.creditCards ?? []).map(r => ({
                amount: !r.amount,
                date: !r.paymentDate,
            })),
            cash: (formData.receiptItems?.cash ?? []).map(r => ({
                amount: !r.amount,
                date: !r.paymentDate,
            })),
            bankTransactions: (formData.receiptItems?.bankTransactions ?? []).map(r => ({
                amount: !r.amount,
                date: !r.paymentDate,
            })),
            offsets: (formData.receiptItems?.offsets ?? []).map(r => ({
                amount: !r.amount,
                date: !r.paymentDate,
            })),
        },
    };


    const checkAuthCompletion = async (authWindow) => {
        setLoading(true);
        try {
            let attempts = 0;
            const maxAttempts = 25;
            while (attempts < maxAttempts) {
                // Check if the authWindow was closed by the user
                if (authWindow.closed) {
                    setLoading(false);
                    toast.error(t('Authentication window was closed by the user.'));
                    return;
                }

                const result = await TaxAuthorityService.checkAuthCompletionClient(client.caseId, taxAuthScopeRef.current);
                if (result.completed) {
                    setLoading(false);
                    setResumeInvoiceCreation(true);
                    // Close the auth window
                    if (authWindow && !authWindow.closed) {
                        authWindow.close();
                    }
                    return;
                } else {
                    attempts += 1;
                    await new Promise((resolve) => setTimeout(resolve, 3000));
                }
            }
            setLoading(false);
            toast.error(t('tokenFetchError'));
            // Close the auth window on timeout
            if (authWindow && !authWindow.closed) {
                authWindow.close();
            }
        } catch (error) {
            console.error('Error checking auth completion:', error);
            setLoading(false);
            toast.error(t('tokenFetchError'));
            // Close the auth window on error
            if (authWindow && !authWindow.closed) {
                authWindow.close();
            }
        }
    };

    useEffect(() => {
        if (resumeInvoiceCreation) {
            handleCreateInvoice(true); // Proceed with invoice creation
        }
    }, [resumeInvoiceCreation]);

    const handleCloseDraftPdfModal = () => {
        setDraftPdfBlob(null);
        setDraftPdfModalVisible(false);
    };

    const handleClosePdfModal = async () => {
        setPdfBlob(null);
        setPdfModalVisible(false);
        handleInvoiceClose();
        handleReset();

        // Stay on page: refresh client data without navigating away
        try {
            const updatedClient = await ClientService.GetClient(token, client.caseId);
            setClient(updatedClient);
            
            // Preserve the original type for navigation to ensure proper remapping on refresh
            // The type in location.state is used to map back to invoiceModalType via typeMapping
            // For invoiceModalType 5 and 6, we keep 'ReceiptTax' or 'Receipt' (not 'PaymentAcceptances')
            // so the page can correctly map it back to invoiceModalType 5 or 6
            const navigationType = type || location.state?.type || 
                (invoiceModalType === 5 ? 'ReceiptTax' : 
                 invoiceModalType === 6 ? 'Receipt' : 
                 InvoiceModalTypes[invoiceModalType]?.type);

            // Clear one-time prefill data so the useEffect won't re-parse item/itemFromLedger
            // and repopulate the form with the receipt we just created
            const { item: _item, itemFromLedger: _itemFromLedger, ...restState } = location.state || {};

            navigate(location.pathname, {
                replace: true,
                state: { ...restState, client: updatedClient, type: navigationType },
            });
        } catch (e) {
            console.error('Error refreshing client:', e);
        }
    };


    const validateDateAndShowWarning = async (selectedDate) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to start of day for accurate comparison
        
        const selectedDateOnly = new Date(selectedDate);
        selectedDateOnly.setHours(0, 0, 0, 0); // Reset time to start of day for accurate comparison
        
        const isPastDate = selectedDateOnly < today;
        const isFutureDate = selectedDateOnly > today;
        
        if (isPastDate || isFutureDate) {
            const dateType = isPastDate ? 'past' : 'future';
            const result = await Swal.fire({
                title: t('DateWarning') || 'Date Warning',
                text: isPastDate 
                    ? (t('DocumentDateInPast') || 'The document date is in the past. Do you want to continue?')
                    : (t('DocumentDateInFuture') || 'The document date is in the future. Do you want to continue?'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: t('Yes') || 'Yes',
                cancelButtonText: t('No') || 'No',
                confirmButtonColor: '#304FFF',
                cancelButtonColor: '#d33'
            });
            
            return result.isConfirmed;
        }
        
        return true; // Date is today, no warning needed
    };

    const onDateChange = async (selectedDate) => {
        if (selectedDate) {
            // First validate the date and show warning if needed
            const shouldContinue = await validateDateAndShowWarning(selectedDate);
            if (!shouldContinue) {
                // User clicked "No", revert to current date (UTC)
                const today = new Date();
                const utcToday = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));
                handleChange("invoiceDate", utcToday);
                handleChange("reportingMonthDate", utcToday);
                setDatePickerKey(prev => prev + 1); // Force re-render
                return;
            }

            const newDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), 10));
            const response1 = await ClientService.CheckIfMonthClosed(client.caseId, newDate, token);
            if (response1.ok) {
                const isClosedReportingMonth = await response1.json();
                if (isClosedReportingMonth) {
                    toast.info(t('MonthReportAlreadyClosedTryAgain'))
                    // Revert to current date when month is closed
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    handleChange("invoiceDate", today);
                    handleChange("reportingMonthDate", today);
                    return
                }
                // Reset the time portion to avoid time zone offset issues
                selectedDate.setHours(0, 0, 0, 0);

                // Format the date manually or use toLocaleDateString for local date representation
                const year = selectedDate.getFullYear();
                const month = selectedDate.getMonth() + 1; // getMonth() is zero-based
                const day = selectedDate.getDate();

                // Ensure two digits for month and day
                const formattedDate = `${year}-${month?.toString().padStart(2, '0')}-${day?.toString().padStart(2, '0')}`;
                handleChange("invoiceDate", new Date(formattedDate));
                handleChange("reportingMonthDate", new Date(formattedDate));
            }
        }
    };


    const handleGoBack = () => {
        // Use the original type for navigation to ensure proper remapping
        // For invoiceModalType 5 and 6, use 'ReceiptTax' or 'Receipt' (not 'PaymentAcceptances')
        // so the page can correctly map it back to invoiceModalType 5 or 6
        const navigationType = type || 
            (invoiceModalType === 5 ? 'ReceiptTax' : 
             invoiceModalType === 6 ? 'Receipt' : 
             InvoiceModalTypes[invoiceModalType]?.type);
        updateLocationState(client, InvoiceModalTypes[invoiceModalType].screen, navigationType)
    }
    const combinedReceiptItems = useMemo(() => {
        const checks = (formData.receiptItems?.checks || []).map((chk, idx) => ({ ...chk, itemType: 'checks', itemTypeIndex: idx }));
        const creditCards = (formData.receiptItems?.creditCards || []).map((cc, idx) => ({ ...cc, itemType: 'creditCards', itemTypeIndex: idx }));
        const cash = (formData.receiptItems?.cash || []).map((c, idx) => ({ ...c, itemType: 'cash', itemTypeIndex: idx }));
        const bankTransactions = (formData.receiptItems?.bankTransactions || []).map((bt, idx) => ({ ...bt, itemType: 'bankTransactions', itemTypeIndex: idx }));
        const offsets = (formData.receiptItems?.offsets || []).map((of, idx) => ({ ...of, itemType: 'offsets', itemTypeIndex: idx }));
        return [...checks, ...creditCards, ...cash, ...bankTransactions, ...offsets];
    }, [formData.receiptItems]);


    const computeRowTotals = (item) => {
        const qty = parseFloat(item.quantity) || 0;
        const price = parseFloat(item.price) || 0;
        const discountPercent = parseFloat(item.discount) || 0;

        const base = qty * price;
        const discountAmount = (base * discountPercent) / 100;
        const totalAfterDiscount = base - discountAmount;

        return { discountAmount, totalAfterDiscount };
    };

    //-------------------------------------------FC-----------------------------------------------

    // 1. Core helper: given an idx, date and amount, fetch the rate and write back the calculated amount
    const recalcAmount = async (itemType, idx, paymentDate, foreignCurrencyAmount, code = null) => {
        // only if we have everything we need


        if (
            formData.foreignCurrencyCode == null ||
            !paymentDate ||
            foreignCurrencyAmount == null
        ) {
            return;
        }

        try {
            const rate = await ForeignCurrencyService.GetIlsRateForDate(
                code != null ? code : formData.foreignCurrencyCode,
                paymentDate
            );
            const amount = Number((foreignCurrencyAmount * rate).toFixed(2));
            // push the new amount into your state
            handleReceiptItemChange(itemType, idx, 'amount', amount);
        } catch (err) {
            console.error('Failed to recalc FC amount', err);
            toast.error(t('CurrencyRateFetchError'));
        }
    };

    // 2) Hold a ref to the latest recalcAmount
    const recalcRef = useRef(recalcAmount);
    useEffect(() => {
        recalcRef.current = recalcAmount;
    }, [recalcAmount]);

    // 3) Create *one* debounced function on mount, pointing at recalcRef.current
    const debouncedRecalc = useRef(
        debounce((itemType, idx, paymentDate, foreignCurrencyAmount) => {
            console.log('debouncedRecalc fired:', {
                itemType,
                idx,
                paymentDate,
                foreignCurrencyAmount
            });
            recalcRef.current(itemType, idx, paymentDate, foreignCurrencyAmount);
        }, 500)
    ).current;

    // 4) Clean it up on unmount
    useEffect(() => {
        return () => {
            debouncedRecalc.cancel();
        };
    }, [debouncedRecalc]);

    const handleForeignAmountChange = (itemType, idx, newForeignAmount) => {
        // 1) immediately update the model


        handleReceiptItemChange(itemType, idx, 'foreignCurrencyAmount', newForeignAmount)

        // 2) schedule a recalc for 500ms after the last keystroke
        const item = formData.receiptItems[itemType]?.[idx]

        debouncedRecalc(itemType, idx, item?.paymentDate, newForeignAmount);
    }


    // 3. When the user changes the payment date
    const handlePaymentDateChange = (itemType, idx, newDate) => {
        handleReceiptItemChange(itemType, idx, 'paymentDate', newDate);
        const foreignCurrencyAmount =
            formData.receiptItems[itemType]?.[idx]?.foreignCurrencyAmount;
        const fnormalAmount =
            formData.receiptItems[itemType]?.[idx]?.amount;
        if (foreignCurrencyAmount) {
            recalcAmount(itemType, idx, newDate, foreignCurrencyAmount);
        } else {
            debouncedRecalcReverse(
                itemType,
                idx,
                fnormalAmount,
                newDate,
                formData.foreignCurrencyCode
            );
        }
    };

    // 4. When the overall currency code changes, re‑run for every item
    const handleCurrencyCodeChange = async (newCode) => {
        handleChange('foreignCurrencyCode', newCode);
        if (newCode != null && formData.invoiceDate) {
            const rate = await ForeignCurrencyService.GetIlsRateForDate(
                newCode,
                formData.invoiceDate
            );
            setCurrencyRate(rate);
            // Update invoice items (already handled above)
            setFormData((prevState) => {
                const updatedItems = prevState.invoiceItems.map((item) => {
                    let foreignCurrencyPrice = item.foreignCurrencyPrice;
                    if (foreignCurrencyPrice == null && item.price && !isNaN(item.price)) {
                        foreignCurrencyPrice = parseFloat(item.price);
                    }
                    if (foreignCurrencyPrice != null && !isNaN(foreignCurrencyPrice)) {
                        const ilsPrice = Number((foreignCurrencyPrice * rate).toFixed(2));
                        return {
                            ...item,
                            foreignCurrencyPrice: foreignCurrencyPrice,
                            price: ilsPrice,
                        };
                    }
                    return item;
                });
                // Update receipt items
                const updateReceiptType = (arr) =>
                    arr.map((item) => {
                        // If user already entered amount but not foreignCurrencyAmount, treat amount as foreign
                        if ((item.amount && !item.foreignCurrencyAmount) || (item.amount && item.foreignCurrencyAmount === '')) {
                            const fcAmount = parseFloat(item.amount);
                            if (!isNaN(fcAmount)) {
                                return {
                                    ...item,
                                    foreignCurrencyAmount: fcAmount,
                                    amount: Number((fcAmount * rate).toFixed(2)),
                                };
                            }
                        } else if (item.foreignCurrencyAmount) {
                            const fcAmount = parseFloat(item.foreignCurrencyAmount);
                            if (!isNaN(fcAmount)) {
                                return {
                                    ...item,
                                    amount: Number((fcAmount * rate).toFixed(2)),
                                };
                            }
                        }
                        return item;
                    });
                return {
                    ...prevState,
                    invoiceItems: updatedItems,
                    receiptItems: {
                        checks: updateReceiptType(prevState.receiptItems.checks || []),
                        creditCards: updateReceiptType(prevState.receiptItems.creditCards || []),
                        cash: updateReceiptType(prevState.receiptItems.cash || []),
                        bankTransactions: updateReceiptType(prevState.receiptItems.bankTransactions || []),
                        offsets: updateReceiptType(prevState.receiptItems.offsets || []),
                    },
                };
            });
        }
    };


    // 2. Reverse‑conversion debounce:
    const debouncedRecalcReverse = useRef(
        debounce(async (
            itemType, idx, amount, paymentDate, codeOverride
        ) => {
            if (!paymentDate || amount == null) return;
            const code = codeOverride ?? formData.foreignCurrencyCode;
            if (!code) return;

            try {
                const rate = await ForeignCurrencyService.GetIlsRateForDate(code, paymentDate);
                const foreignAmt = Number((amount / rate).toFixed(2));
                handleReceiptItemChange(itemType, idx, 'foreignCurrencyAmount', foreignAmt);
            } catch (err) {
                console.error('Failed to recalc reverse FC amount', err);
                toast.error(t('CurrencyRateFetchError'));
            }
        }, 500)
    ).current;


    // 4. New handler for the "normal" amount → foreignCurrencyAmount:
    const handleAmountChange = (itemType, idx, newAmount) => {
        // immediately update model
        handleReceiptItemChange(itemType, idx, 'amount', newAmount);

        // schedule reverse‑conversion
        const paymentDate = formData.receiptItems[itemType]?.[idx]?.paymentDate;
        debouncedRecalcReverse(
            itemType,
            idx,
            parseFloat(newAmount),
            paymentDate,
            formData.foreignCurrencyCode
        );
    };


    const handleChangeItemPrice = async (index, value) => {
        handleItemChange(index, 'foreignCurrencyPrice', value);
        if (formData.foreignCurrencyCode != null && formData.invoiceDate) {
            let rate = currencyRateValue;
            if (!rate) {
                rate = await ForeignCurrencyService.GetIlsRateForDate(
                    formData.foreignCurrencyCode,
                    formData.invoiceDate
                );
                setCurrencyRate(rate);
            }
            const amount = Number((value * rate).toFixed(2));
            handleItemChange(index, 'price', amount);
        } else {
            handleItemChange(index, 'price', value);
        }
    }


    const handlePriceIncludingVATChange = async (event) => {
        // If forceNoTax is true, don't allow priceIncludingVAT changes
        if (formData.forceNoTax) {
            return;
        }
        
        const newValue = event.target.value === 'true';
        setFormData((prevState) => ({
            ...prevState,
            priceIncludingVAT: newValue,
        }));

        // Update all items' VAT settings to match the new global setting
        // Only update items that haven't been manually overridden
        setFormData((prevState) => {
            const updatedItems = prevState.invoiceItems.map((item) => {
                // If the item doesn't have a manually set includeVat (undefined), 
                // update it to match the new global setting
                if (item.includeVat === undefined) {
                    return {
                        ...item,
                        includeVat: formData.forceNoTax ? false : newValue
                    };
                }
                // If the item has a manually set includeVat, keep it as is
                return item;
            });
            
            return {
                ...prevState,
                invoiceItems: updatedItems,
            };
        });

        // Only recalc if foreign currency is selected
        // if (formData.foreignCurrencyCode != null && formData.invoiceDate) {
        //     let rate = currencyRateValue;
        //     if (!rate) {
        //         rate = await ForeignCurrencyService.GetIlsRateForDate(
        //             formData.foreignCurrencyCode,
        //             formData.invoiceDate
        //         );
        //         setCurrencyRate(rate);
        //     }
        //     const VAT = getVatValue(formData.invoiceDate);
        //     setFormData((prevState) => {
        //         const updatedItems = prevState.invoiceItems.map((item) => {
        //             let foreignCurrencyPrice = item.foreignCurrencyPrice;
        //             if (foreignCurrencyPrice == null && item.price && !isNaN(item.price)) {
        //                 // If foreignCurrencyPrice is not set, but price is, treat price as foreign currency
        //                 foreignCurrencyPrice = parseFloat(item.price);
        //             }
        //             if (foreignCurrencyPrice != null && !isNaN(foreignCurrencyPrice)) {
        //                 let ilsPrice = Number((foreignCurrencyPrice * rate).toFixed(2));
        //                 if (!newValue) {
        //                     // Include VAT
        //                     ilsPrice = Number((ilsPrice * (1 + VAT)).toFixed(2));
        //                 }
        //                 // else, price is just ilsPrice (without VAT)
        //                 return {
        //                     ...item,
        //                     price: ilsPrice,
        //                 };
        //             }
        //             return item;
        //         });
        //         return {
        //             ...prevState,
        //             invoiceItems: updatedItems,
        //         };
        //     });
        // }
    };
    //------------------------------------------------------------------------------------------

    const receiptComboInputProps = { disableUnderline: true };
    const getReceiptTableFieldClassName = (hasError = false) =>
        [fieldStyles.styleInput, receiptFieldStyles.softField, hasError ? fieldStyles.styleInputRequired : '']
            .filter(Boolean)
            .join(' ');
    const toReceiptPickerDate = (value) => {
        if (value == null || value === '') return null;
        const d = value instanceof Date ? value : new Date(value);
        return Number.isNaN(d.getTime()) ? null : d;
    };

    const handleFillReceiptBankRows = (targets, details) => {
        setFormData((prevState) => {
            const receiptItems = { ...prevState.receiptItems };
            targets.forEach(({ itemType, itemTypeIndex }) => {
                const items = [...(receiptItems[itemType] || [])];
                items[itemTypeIndex] = { ...items[itemTypeIndex], ...details };
                receiptItems[itemType] = items;
            });
            return { ...prevState, receiptItems };
        });
    };

    const handleReceiptCardBankDetailsSaved = (updatedCard) => {
        const key = normalizeCardId(updatedCard?.cardId ?? updatedCard?.CardId);
        setAccountCardOptions((prev) =>
            prev.map((option) => (normalizeCardId(option.cardId ?? option.CardId) === key ? updatedCard : option))
        );
    };

    const renderReceiptBankDetailsBar = () => {
        if (!formData.invoiceAccountCodeId || formData.invoiceAccountCodeId === 'AddItem') return null;
        return (
            <AccountCardBankDetailsBar
                t={t}
                direction={direction}
                caseId={client?.caseId}
                token={token}
                card={findAccountCardById(formData.invoiceAccountCodeId)}
                rows={combinedReceiptItems}
                onFillRows={handleFillReceiptBankRows}
                onCardSaved={handleReceiptCardBankDetailsSaved}
            />
        );
    };

    const renderReceiptRows = () => {
        const fieldTextAlign = direction === 'ltr' ? 'left' : 'right';
        return combinedReceiptItems.map((row, index) => {
            // We detect whether the row is disabled
            const isDisabled = false; // or use the logic from the code: !isRange ? formData?.isClosedReportingMonth : isClosedReportingMonth

            return (
                <TableRow key={`${row.itemType}-${index}`}>
                    {/* [ADDED] Type */}
                    <TableCell>{t(row.itemType)}</TableCell>

                    {/* [ADDED] CheckNumber / Description */}
                    <TableCell>
                        {row.itemType === 'checks' ? (
                            <TextField
                                fullWidth
                                placeholder={t('CheckNumber')}
                                value={row.description || ''}
                                onChange={(e) =>
                                    handleReceiptItemChange(row.itemType, row.itemTypeIndex, 'description', e.target.value)
                                }
                                variant="standard"
                                size="small"
                                className={getReceiptTableFieldClassName(
                                    !!fieldErrors.receiptItems[row.itemType]?.[row.itemTypeIndex]?.description
                                )}
                                InputProps={receiptComboInputProps}
                                inputProps={{
                                    style: { textAlign: fieldTextAlign },
                                }}
                                disabled={isDisabled}
                            />
                        ) : (
                            <TextField
                                fullWidth
                                placeholder={row.itemType === 'creditCards' ? t('Last 4 credit card digits') : t('Description')}
                                value={row.description || ''}
                                onChange={(e) =>
                                    handleReceiptItemChange(row.itemType, row.itemTypeIndex, 'description', e.target.value)
                                }
                                variant="standard"
                                size="small"
                                className={getReceiptTableFieldClassName(false)}
                                InputProps={receiptComboInputProps}
                                inputProps={{
                                    style: { textAlign: fieldTextAlign },
                                }}
                                disabled={isDisabled}
                            />
                        )}
                    </TableCell>

                    {/* [ADDED] BankName (checks and bank transfers) */}
                    <TableCell>
                        {(row.itemType === 'checks' || row.itemType === 'bankTransactions') ? (
                            <AutocompleteSelectFilter
                                options={Constants.ISRAEL_BANKS.map((b) => ({
                                    value: b.code,
                                    label: `${b.code} – ${b.name}`,
                                }))}
                                selectedValues={(() => {
                                    const bank = Constants.ISRAEL_BANKS.find(
                                        (b) => b.code === row.bankCode || b.name === row.bankName
                                    );
                                    return bank
                                        ? { value: bank.code, label: `${bank.code} – ${bank.name}` }
                                        : null;
                                })()}
                                onChange={(_, newVal) => {
                                    const newName = newVal
                                        ? (Constants.ISRAEL_BANKS.find((b) => b.code === newVal.value)?.name || '')
                                        : '';
                                    const newCode = newVal ? newVal.value : '';
                                    handleReceiptItemChange(row.itemType, row.itemTypeIndex, 'bankName', newName);
                                    handleReceiptItemChange(row.itemType, row.itemTypeIndex, 'bankCode', newCode);
                                }}
                                placeholder={t('BankName')}
                                isMultiple={false}
                                clearable
                                searchable
                                direction={direction}
                                portalMenu
                                isDisabled={isDisabled}
                            />
                        ) : (
                            <span>-</span>
                        )}
                    </TableCell>

                    {/* [ADDED] BankCode (checks and bank transfers) */}
                    <TableCell>
                        {(row.itemType === 'checks' || row.itemType === 'bankTransactions') ? (
                            <TextField
                                fullWidth
                                type="number"
                                placeholder={t('BankCode')}
                                value={row.bankCode || ''}
                                onChange={(e) =>
                                    handleReceiptItemChange(row.itemType, row.itemTypeIndex, 'bankCode', e.target.value)
                                }
                                variant="standard"
                                size="small"
                                className={getReceiptTableFieldClassName(false)}
                                InputProps={receiptComboInputProps}
                                inputProps={{
                                    style: { textAlign: fieldTextAlign },
                                }}
                                disabled
                            />
                        ) : (
                            <span>-</span>
                        )}
                    </TableCell>

                    {/* [ADDED] BankBranchCode (checks and bank transfers) */}
                    <TableCell>
                        {(row.itemType === 'checks' || row.itemType === 'bankTransactions') ? (
                            <TextField
                                fullWidth
                                type="number"
                                placeholder={t('BankBranchCode')}
                                value={row.bankBranchCode || ''}
                                onChange={(e) =>
                                    handleReceiptItemChange(row.itemType, row.itemTypeIndex, 'bankBranchCode', e.target.value)
                                }
                                variant="standard"
                                size="small"
                                className={getReceiptTableFieldClassName(false)}
                                InputProps={receiptComboInputProps}
                                inputProps={{
                                    style: { textAlign: fieldTextAlign },
                                }}
                                disabled={isDisabled}
                            />
                        ) : (
                            <span>-</span>
                        )}
                    </TableCell>

                    {/* [ADDED] SupplierAccountNumber (checks and bank transfers) */}
                    <TableCell>
                        {(row.itemType === 'checks' || row.itemType === 'bankTransactions') ? (
                            <TextField
                                fullWidth
                                type="number"
                                placeholder={t('SupplierAccountNumber')}
                                value={row.supplierAccountNumber || ''}
                                onChange={(e) =>
                                    handleReceiptItemChange(row.itemType, row.itemTypeIndex, 'supplierAccountNumber', e.target.value)
                                }
                                variant="standard"
                                size="small"
                                className={getReceiptTableFieldClassName(false)}
                                InputProps={receiptComboInputProps}
                                inputProps={{
                                    style: { textAlign: fieldTextAlign },
                                }}
                                disabled={isDisabled}
                            />
                        ) : (
                            <span>-</span>
                        )}
                    </TableCell>

                    {/* [ADDED] Amount */}
                    <TableCell>
                        <Tooltip title={String(formData.foreignCurrencyCode != null ? (row.foreignCurrencyAmount || '') : (row.amount || ''))} arrow placement="top">
                            <TextField
                                fullWidth
                                type="number"
                                placeholder={formData.foreignCurrencyCode != null ? t('CurrencyAmount') : t('Amount')}
                                value={formData.foreignCurrencyCode != null ? (row.foreignCurrencyAmount || '') : (row.amount || '')}
                                onChange={(e) =>
                                    formData.foreignCurrencyCode != null
                                        ? handleForeignAmountChange(row.itemType, row.itemTypeIndex, e.target.value)
                                        : handleAmountChange(row.itemType, row.itemTypeIndex, e.target.value)
                                }
                                variant="standard"
                                size="small"
                                className={getReceiptTableFieldClassName(
                                    !!fieldErrors.receiptItems[row.itemType]?.[row.itemTypeIndex]?.amount
                                )}
                                InputProps={receiptComboInputProps}
                                inputProps={{
                                    onWheel: (e) => e.target.blur(),
                                    step: 'any',
                                    style: { textAlign: fieldTextAlign },
                                }}
                                disabled={isDisabled}
                            />
                        </Tooltip>
                    </TableCell>

                    {/* [ADDED] Reference */}
                    <TableCell>
                        <TextField
                            fullWidth
                            type="number"
                            placeholder={t('Reference2')}
                            value={row.reference2 || ''}
                            onChange={(e) =>
                                handleReceiptItemChange(row.itemType, row.itemTypeIndex, 'reference2', e.target.value)
                            }
                            variant="standard"
                            size="small"
                            className={getReceiptTableFieldClassName(false)}
                            InputProps={receiptComboInputProps}
                            inputProps={{
                                onWheel: (e) => e.target.blur(),
                                style: { textAlign: fieldTextAlign },
                            }}
                            disabled={isDisabled}
                        />
                    </TableCell>

                    {/* [ADDED] Date */}
                    <TableCell>
                        <DatePicker
                            value={toReceiptPickerDate(row.paymentDate)}
                            onChange={(date) => {
                                if (date) {
                                    handlePaymentDateChange(row.itemType, row.itemTypeIndex, date);
                                }
                            }}
                            format="dd/MM/yyyy"
                            disabled={isDisabled}
                            slotProps={{
                                textField: {
                                    variant: 'standard',
                                    fullWidth: true,
                                    size: 'small',
                                    className: getReceiptTableFieldClassName(!row.paymentDate),
                                    InputProps: receiptComboInputProps,
                                    error: !row.paymentDate,
                                    inputProps: {
                                        style: { textAlign: fieldTextAlign },
                                    },
                                },
                                popper: {
                                    sx: { zIndex: 1700 },
                                },
                            }}
                        />
                    </TableCell>

                    {/* [ADDED] Document Upload */}
                    <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            {row.documentFile || row.documentUrl ? (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Tooltip title={row.documentFile ? row.documentFile.name : t('DocumentAttached')}>
                                        <IconButton
                                            size="small"
                                            sx={{ color: '#28a745' }}
                                            onClick={() => row.documentUrl && window.open(row.documentUrl, '_blank')}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                                            </svg>
                                        </IconButton>
                                    </Tooltip>
                                    {!isDisabled && (
                                        <IconButton
                                            size="small"
                                            onClick={() => handleReceiptItemFileRemove(row.itemType, row.itemTypeIndex)}
                                            sx={{ color: '#dc3545' }}
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                            ) : (
                                !isDisabled && (
                                    <Button
                                        variant="outlined"
                                        component="label"
                                        size="small"
                                        sx={{
                                            borderColor: '#304FFF',
                                            color: '#304FFF',
                                            minWidth: 'auto',
                                            padding: '4px 8px',
                                            '&:hover': { backgroundColor: '#304FFF', color: 'white' }
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: 4 }}>
                                            <path d="M9 16h6v-6h4l-7-7-7 7h4v6zm-4 2h14v2H5z"/>
                                        </svg>
                                        {t('Upload')}
                                        <input
                                            type="file"
                                            hidden
                                            accept="image/*,application/pdf"
                                            onChange={(e) => handleReceiptItemFileUpload(row.itemType, row.itemTypeIndex, e)}
                                        />
                                    </Button>
                                )
                            )}
                        </Box>
                    </TableCell>

                    {/* [ADDED] Remove button */}
                    <TableCell>
                        {!isDisabled && (
                            <IconButton
                                color="error"
                                size="small"
                                onClick={() => handleRemoveReceiptItem(row.itemType, row.itemTypeIndex)}
                                aria-label={t('RemoveItem')}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        )}
                    </TableCell>
                </TableRow>
            );
        });
    };


    return (
        <>

            <style>
                {`
                    .form-container2 {
                        animation: fadeIn 0.6s ease-out;
                        border-radius: 16px;
                        padding: 0.1rem;
                        margin: 0.1rem 1rem 0rem 1rem;
                 
                    }
                    
                    .form-section {
                        background: #f6f7fa;
                        border-radius: 16px;
                        padding: 0.75rem;
                        margin: 0.1rem 0;
                        border: 1px solid rgba(255,255,255,0.2);
                        backdrop-filter: blur(10px);
                        animation: slideIn 0.8s ease-out;
                    }
                    
                    .form-row {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                        gap: 1rem;
                        margin: 1rem 0;
                    }
                    
                    .form-row-item {
                        position: relative;
                    }
                    
                    .form-row-item-title {
                        font-weight: 600;
                        color: #2c3e50;
                        margin-bottom: 0.5rem;
                        font-size: 0.95rem;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }
                    
                    .required-asterisk {
                        color: #e74c3c;
                        margin-left: 4px;
                    }
                    
                    .custom-input {
                        transition: all 0.3s ease;
                        border-radius: 12px;
                        border: 2px solid transparent;
                    }
                    
                    .custom-input:focus-within {
                        border-color: #304FFF;
                        box-shadow: 0 0 0 3px rgba(48, 79, 255, 0.1);
                        transform: translateY(-2px);
                    }
                    
                    .table-container {
                        background: white;
                        border-radius: 16px;
                        overflow: hidden;
                        box-shadow: 0 8px 32px rgba(0,0,0,0.1);
                        margin: 2rem 0;
                    }
                    
                    .table-header {
                        background: linear-gradient(135deg, #304FFF 0%, #1E40FF 100%);
                        color: white;
                        padding: 1rem;
                        font-weight: 600;
                    }
                    
                    
                    
                    .button-group {
                        display: flex;
                        gap: 1rem;
                        flex-wrap: wrap;
                        margin: 1rem 0;
                    }
                    
                    .action-button {
                        background: linear-gradient(135deg, #304FFF 0%, #1E40FF 100%);
                        color: white;
                        border: none;
                        padding: 0.75rem 1.5rem;
                        border-radius: 12px;
                        font-weight: 600;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;
                        box-shadow: 0 4px 15px rgba(48, 79, 255, 0.3);
                    }
                    
                    .action-button:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 6px 20px rgba(48, 79, 255, 0.4);
                    }
                    
                    .action-button:disabled {
                        background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
                        cursor: not-allowed;
                        transform: none;
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                    }
                    
                    .section-title {
                        color: #2c3e50;
                        font-size: 1.8rem;
                        font-weight: 700;
                        margin: 0.5rem 0 0.5rem 0;
                        border-bottom: 3px solid #304FFF;
                        display: inline-block;
                        position: relative;
                    }
                    
                    .section-title::after {
                        content: '';
                        position: absolute;
                        bottom: -3px;
                        left: 0;
                        width: 50px;
                        height: 3px;
                        background: #e74c3c;
                    }
                    
                    .divider {
                        border-top: 2px solid #e9ecef;
                        margin: 2rem 0;
                        position: relative;
                    }
                    
                    .divider::before {
                        content: '';
                        position: absolute;
                        top: -1px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 100px;
                        height: 2px;
                        background: linear-gradient(90deg, transparent, #304FFF, transparent);
                    }
                    
                    @media (max-width: 768px) {
                        .form-row {
                            grid-template-columns: 1fr;
                        }

                        
                        .button-group {
                            flex-direction: column;
                        }
                        
                        .action-button {
                            width: 100%;
                            justify-content: center;
                        }
                    }
                `}
            </style>

            <InactiveClientAlert client={client} />

            <div className="form-container2">
                <div className="form-section">

                    {/* Linked invoice picker — shown only for a regular Receipt
                        (invoiceModalType === 6) when the selected client card
                        has PaymentTerms configured. Lets the user attach this
                        receipt to a specific outstanding invoice so it appears
                        as paid on the Accounts Receivable page. */}
                    {isReceiptWithLinkSupport && cardHasPaymentTerms && (
                        <div
                            dir={direction}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 4,
                                padding: '10px 12px',
                                marginBottom: 12,
                                borderRadius: 8,
                                background: '#F5F7FF',
                                border: '1px solid #DDE3FF',
                            }}
                        >
                            <div style={{ fontWeight: 600, fontSize: 13, color: '#304FFF' }}>
                                {t('LinkedInvoice', 'Linked Invoice')}
                            </div>
                            <Autocomplete
                                freeSolo
                                disabled={loading}
                                loading={isLoadingOutstandingInvoices}
                                options={outstandingInvoices}
                                getOptionLabel={(o) => {
                                    if (!o) return '';
                                    if (typeof o === 'string') return o;
                                    const ref = o.reference || '';
                                    const date = o.documentDate
                                        ? new Date(o.documentDate).toLocaleDateString()
                                        : '';
                                    const remaining = o.remainingAmount != null
                                        ? Number(o.remainingAmount).toLocaleString()
                                        : '';
                                    return [
                                        ref,
                                        date,
                                        remaining ? `${t('Remaining', 'Remaining')}: ${remaining}` : '',
                                    ].filter(Boolean).join(' · ');
                                }}
                                isOptionEqualToValue={(opt, val) =>
                                    (opt?.id && val?.id && opt.id === val.id)
                                    || (opt?.reference && val?.reference && opt.reference === val.reference)
                                }
                                value={linkedInvoiceValue}
                                onChange={(_, v) => {
                                    if (v && typeof v === 'object' && v.id) {
                                        setRelatedIncomeId(v.id);
                                        setRelatedInvoiceReference(v.reference || null);
                                    } else if (v && (typeof v === 'string' || v.reference)) {
                                        setRelatedIncomeId(null);
                                        setRelatedInvoiceReference(typeof v === 'string' ? v : v.reference);
                                    } else {
                                        setRelatedIncomeId(null);
                                        setRelatedInvoiceReference(null);
                                    }
                                }}
                                onInputChange={(_, value, reason) => {
                                    if (reason === 'input') {
                                        setRelatedIncomeId(null);
                                        setRelatedInvoiceReference(value || null);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        variant="outlined"
                                        placeholder={t('LinkedInvoicePlaceholder', 'Pick or type invoice number')}
                                    />
                                )}
                            />
                            <div style={{ fontSize: 11, color: '#6C757D' }}>
                                {t('CardHasPaymentTermsHint',
                                    'This card has payment terms; receipts can be linked to specific invoices.')}
                            </div>
                        </div>
                    )}

                    {/* Form Inputs Section */}
                    <EnhancedCreateReceipt
                        formData={formData}
                        setFormData={setFormData}
                        handleChange={handleChange}
                        handleAccountCodeChange={handleAccountCodeChange}
                        handleCurrencyCodeChange={handleCurrencyCodeChange}
                        handlePriceIncludingVATChange={handlePriceIncludingVATChange}
                        handleItemVATChange={handleItemVATChange}
                        handleInvoiceItem={handleInvoiceItem}
                        handleMakatBlurOrEnter={handleMakatBlurOrEnter}
                        handleItemChange={handleItemChange}
                        handleItemDiscountAmountChange={handleItemDiscountAmountChange}
                        handleChangeItemPrice={handleChangeItemPrice}
                        handleRemoveItem={handleRemoveItem}
                        handleAddItem={handleAddItem}
                        handleAddReceiptItem={handleAddReceiptItem}
                        handleCreateDraftInvoice={handleCreateDraftInvoice}
                        handleCloseAddNewAccountCardDocument={handleCloseAddNewAccountCardDocument}
                        handleCloseAddItem={handleCloseAddItem}
                        onDateChange={onDateChange}
                        datePickerKey={datePickerKey}
                        computeRowTotals={computeRowTotals}
                        beautifyNumber={beautifyNumber}
                        styledInput={styledInput}
                        Constants={Constants}
                        direction={direction}
                        t={t}
                        currentUILanguage={i18n.language}
                        showNoTaxCheckbox={showNoTaxCheckbox}
                        addNewAccountCardDocument={addNewAccountCardDocument}
                        showAllAccountCards={showAllAccountCards}
                        setShowAllAccountCards={setShowAllAccountCards}
                        formattedAccountCardOptions={formattedAccountCardOptions}
                        fieldErrors={fieldErrors}
                        allClientItemFieldsFilled={allClientItemFieldsFilled}
                        invoiceModalType={invoiceModalType}
                        client={client}
                        clientItems={clientItems}
                        addItemFlags={addItemFlags}
                        isAmountAboveLimit={isAmountAboveLimit}
                        totalInvoiceAmount={totalInvoiceAmount}
                        totalReceiptAmount={totalReceiptAmount}
                        totalVATAmount={totalVATAmount}
                        totalAmountWithoutVAT={totalAmountWithoutVAT}
                        totalsVisible={totalsVisible}
                        setTotalsVisible={setTotalsVisible}
                        withholdingTaxRowAdded={withholdingTaxRowAdded}
                        setWithholdingTaxRowAdded={setWithholdingTaxRowAdded}
                        handleAddWithholdingTaxClick={handleAddWithholdingTaxClick}
                        handleRemoveWithholdingTaxRow={handleRemoveWithholdingTaxRow}
                        handleRoundReceipt={handleRoundReceipt}
                        receiptClientDeductionRatePercent={receiptClientDeductionRatePercent}
                        receiptWithholdingFormulaAmount={receiptWithholdingFormulaAmount}
                        calculatedWithholdingAmount={calculatedWithholdingAmount}
                        autoClientWithholding={autoClientWithholding}
                        handleReceiptAutoWithholdingChange={handleReceiptAutoWithholdingChange}
                        withholdingPercent={withholdingPercent}
                        handleWithholdingPercentChange={handleWithholdingPercentChange}
                        renderReceiptRows={renderReceiptRows}
                        renderReceiptBankDetailsBar={renderReceiptBankDetailsBar}
                        handleCreateInvoice={handleCreateInvoice}
                        type={type}
                        linking={receiptLinking}
                        deferredReceipt={deferredReceipt}
                        setDeferredReceipt={setDeferredReceipt}
                        // Add missing props that might be needed
                        user={user}
                        token={token}
                        loading={loading}
                        setLoading={setLoading}
                        CustomDatePicker={CustomDatePicker}
                        AutocompleteSelect={AutocompleteSelect}
                        allItemsHaveNoVATCalculation={allItemsHaveNoVATCalculation}
                        itemsDisplayMode={itemsDisplayMode}
                        segmentationProjects={segmentationProjects}
                        selectedSegmentation={selectedSegmentation}
                        onSegmentationChange={setSelectedSegmentation}
                        refreshSegmentationProjects={refreshSegmentationProjects}
                    />
                </div>
            </div>


            <div
                className={`floating-totals-badge ${totalsVisible ? 'expanded' : 'collapsed'}`}
                style={{
                    position: 'fixed',
                    top: '20%',
                    left: 0,
                    zIndex: 99999,
                    background: '#ffffff',
                    borderTopRightRadius: '16px',
                    borderBottomRightRadius: '16px',
                    boxShadow: '2px 4px 12px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease',
                    overflow: 'hidden',
                    width: totalsVisible ? '260px' : '50px',
                    minHeight: '60px',
                    fontFamily: "'Segoe UI', Tahoma, sans-serif",
                    color: '#333',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'auto'
                }}
            >
                <div className="totals-header" onClick={() => setTotalsVisible(!totalsVisible)}>
                    {totalsVisible ? <ChevronLeft /> : <ChevronRight />}
                </div>

                {totalsVisible && (
                    <div className="totals-content" dir={direction}>
                        {invoiceModalType === 5 && (
                            <>
                                <div className="total-row">
                                    <span>{t('TotalInvoiceAmount')}</span>
                                    <strong>{beautifyNumber(totalInvoiceAmount)}₪</strong>
                                </div>
                                <div className="total-row">
                                    <span>{t('TotalReceiptAmount')}</span>
                                    <strong>{beautifyNumber(totalReceiptAmount)}₪   </strong>
                                </div>
                                <div className="total-row">
                                    <span>{t('Difference')}</span>
                                    <strong>{beautifyNumber(totalInvoiceAmount - totalReceiptAmount)}₪</strong>
                                </div>
                                <div className="total-row">
                                            <span>{t('VATAmount')}</span>
                                            <strong>{beautifyNumber(totalVATAmount)}₪</strong>
                                </div>
                                <div className="total-row">
                                    <span>{t('TotalWithoutVAT')}</span>
                                    <strong>{beautifyNumber(totalAmountWithoutVAT)}₪</strong>
                                </div>
                            </>
                        )}

                        {invoiceModalType === 6 && (
                            <div className="total-row">
                                <span>{t('TotalReceiptAmount')}</span>
                                <strong>{beautifyNumber(totalReceiptAmount)}</strong>
                            </div>
                        )}

                        {(invoiceModalType !== 5 && invoiceModalType !== 6) && (
                            <>
                                <div className="total-row">
                                    <span>{t('TotalInvoiceAmount')}</span>
                                    <strong>{beautifyNumber(totalInvoiceAmount)}</strong>
                                </div>
                                {!Constants.TaxExemptTypes.includes(client?.caseType) && !formData.forceNoTax && (
                                    <>
                                        <div className="total-row">
                                            <span>{t('VATAmount')}</span>
                                            <strong>{beautifyNumber(totalVATAmount)}</strong>
                                        </div>
                                        <div className="total-row">
                                            <span>{t('TotalWithoutVAT')}</span>
                                            <strong>{beautifyNumber(totalAmountWithoutVAT)}</strong>
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                )}
            </div>

            {/* Signature Reference Modal */}
            <SignatureReferenceModal
                isVisible={signatureReferenceInvoiceModalVisible}
                onClose={handleSignatureReferenceClose}
                onSave={handleSignatureReferenceSave}
                invoiceReference={invoiceReference}
                setInvoiceReference={setInvoiceReference}
                invoiceSignature={invoiceSignature}
                setInvoiceSignature={setInvoiceSignature}
                direction={direction}
                needSignature={needSignature}
                needReference={needReference}
                type={t(type)}
            />

            {/* Draft PDF Modal */}
            <Modal
                open={draftPdfModalVisible}
                onClose={handleCloseDraftPdfModal}
                aria-labelledby="draft-invoice-modal-title"
                aria-describedby="draft-invoice-modal-description"
            >
                <div className="draft-pdf-modal-container">
                    {/* PDF preview */}
                    {draftPdfBlob && (
                        <iframe
                            src={URL.createObjectURL(draftPdfBlob)}
                            width="100%"
                            height="100%"
                            style={{ border: 'none' }}
                            aria-label="Draft Invoice PDF"
                        />
                    )}

                    {/* Buttons */}
                    <div className="draft-pdf-button-container">
                        {!!client?.email && (
                            <label className="draft-send-to-creator">
                                <input
                                    type="checkbox"
                                    checked={!!formData.sendToCreator}
                                    onChange={(e) => setFormData(prev => ({ ...prev, sendToCreator: e.target.checked }))}
                                />
                                <span className="draft-send-to-creator-text">
                                    <span className="draft-send-to-creator-title">{t('SendToCreator')}</span>
                                    <span className="draft-send-to-creator-email">{client.email}</span>
                                </span>
                            </label>
                        )}
                        <button
                            className={`create-invoice-button ${!allClientItemFieldsFilled ? 'button-disabled' : ''}`}
                            onClick={allClientItemFieldsFilled ? () => handleCreateInvoice() : null}
                            disabled={!allClientItemFieldsFilled}
                        >
                            <span>{t(type)}</span>
                        </button>

                        <button className="close-invoice-button" onClick={handleCloseDraftPdfModal}>
                            {t('close')}
                        </button>
                    </div>
                </div>
            </Modal>

            {/* PDF Modal */}
            <Modal
                open={PdfModalVisible}
                onClose={handleClosePdfModal}
                aria-labelledby="draft-invoice-modal-title"
                aria-describedby="draft-invoice-modal-description"
            >
                <div className="draft-pdf-modal-container">
                    {/* PDF preview */}
                    {PdfBlob && (
                        <iframe
                            src={URL.createObjectURL(PdfBlob)}
                            width="100%"
                            height="100%"
                            style={{ border: 'none' }}
                            aria-label="Draft Invoice PDF"
                        />
                    )}

                    {/* Buttons */}
                    <div className="draft-pdf-button-container">
                        <button className="close-invoice-button" onClick={handleClosePdfModal}>
                            {t('close')}
                        </button>
                    </div>
                </div>
            </Modal>

            {loading && (
                <div className="loader-container">
                    <PuffLoader
                        size={100}        // Larger size for better visibility
                        loading={loading}
                    />
                </div>
            )}

            {/* Tax Authority Error Modal */}
            <TaxAuthorityErrorModal
                open={isTaxAuthorityErrorModalVisible}
                onClose={() => {
                    setIsTaxAuthorityErrorModalVisible(false);
                    setResolvePendingMode(false);
                    setPendingDecisionStatus(null);
                }}
                onOptionSelect={handleTaxAuthorityOptionSelect}
                invoiceData={{
                    invoiceId: pendingDecisionStatus?.invoiceId || formData.invoiceId || "0"
                }}
                caseId={client?.caseId || "0"}
                token={token}
                isInvoiceReceipt={invoiceModalType === 5}
                pendingStatus={pendingDecisionStatus}
                resolvePending={resolvePendingMode}
                onResolved={handlePendingDecisionResolved}
            />

            <ItemPricePickerDialog
                open={!!pricePickerState}
                prices={pricePickerState?.prices || []}
                itemName={pricePickerState?.itemName || ''}
                direction={direction}
                onClose={() => setPricePickerState(null)}
                onSelect={async (chosen) => {
                    const apply = pricePickerState?.apply;
                    setPricePickerState(null);
                    if (apply) await apply(chosen.amount);
                }}
            />
            
            <ToastContainer />
        </>
    );


};

export default CreateReceipt;